<template>
  <div id="productSku" style="width:100%;height: 100%;padding: 20px;background: white;
    box-sizing:border-box" v-loading.fullscreen.lock.body="loading" :element-loading-text="loadingText"
    element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <div
      style="height:calc(100% + 12px);background: white;min-width: 360px;float: left;display: flex; flex-direction: column;">
      <el-row style="height: 30px">
        <el-col :span="24">
          <el-col :span="24" style="text-align: end;">
            <span style="font-size: 20px;float: left;line-height: 30px;">产品管理</span>
            <el-button type="primary" size="small" icon="el-icon-download" @click="daoru">导入导出 </el-button>
            <el-button type="success" icon="el-icon-plus" size="small" @click="open3" style="background: #4EC880;">新增品类
            </el-button>
          </el-col>
        </el-col>
      </el-row>
      <el-row style="height: 100%;;overflow: hidden;" id="seachRowSKU">
        <el-col :span="24" style="height: 100%;">
          <div style=" border: 1px solid #eee;border-bottom: none">
            <el-input style="padding:5px" class="sWei" placeholder="请输入品类名称进行快速检索" v-model="filterText">
            </el-input>
          </div>
          <!--:class="$style.scrollbar"-->
          <el-scrollbar style="height:calc(100% - 43px);border: 1px solid #eee;
                    border-top:none;">
            <el-tree class="filter-tree" :data="data" @node-click="handleNodeClick" :props="defaultProps"
              node-key="define_id" :highlight-current="true" :expand-on-click-node="false"
              :filter-node-method="filterNode" :default-expanded-keys="[1000, 2000]" ref="tree">
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span>
                  {{ node.label }}
                </span>
              </span>
            </el-tree>
          </el-scrollbar>
        </el-col>
      </el-row>
    </div>
    <div class="StoCen" style="height: auto;float: right;width: calc(100% - 370px);overflow: auto">
      <el-row style="margin-bottom: 4px" type="flex" align="middle">
        <el-col :span="21" style="color: #409EFF;font-size: 20px;line-height: 20px">{{ schTitle1 }} <span
            v-if="schTitle1Code != ''">（{{ schTitle1Code }}）</span></el-col>
        <el-col :span="3">
          <el-button type="warning" size="small" :disabled="!updataActive"
            @click="() => open4(this.dataNode, this.nodeData)" :style="{ float: 'right' }" style="font-size: 12px;font-weight: bold;
                    background:#FF9901;border-color: #FF9901" id="el-button">编辑
          </el-button>
        </el-col>
      </el-row>
      <el-row class="xux"></el-row>
      <!--            <el-row v-for="(item,index) in valueArr" :key="index" style="font-size: 12px;height: auto">-->
      <!--            说明{{index+1}}:{{item}}-->
      <!--        </el-row>-->

      <el-row style="margin-top: 40px">
        <el-col :span="24" style="text-align: center">
          <el-button-group>
            <el-button @click="clickTab('SKU')" :class="isProductType === 'SKU' ? 'buttonStyleActive' : 'buttonStyle'"
              style="">SKU
            </el-button>
            <el-button :class="isProductType === 'TRIAL' ? 'buttonStyleActive' : 'buttonStyle'"
              @click="clickTab('样品')">样品
            </el-button>
            <el-button :class="isProductType === 'COMPETITOR' ? 'buttonStyleActive' : 'buttonStyle'"
              @click="clickTab('竞品')">竞品
            </el-button>
          </el-button-group>
        </el-col>
      </el-row>

      <el-row v-if="isProductType === 'SKU'">
        <el-row type="flex" align="middle">
          <el-col :span="16" style="font-size: 12px;color: #409EFF;margin-top:20px ">SKU数：{{ tableData.length }}个
          </el-col>
          <el-col :span="8" style="text-align: end;">
            <el-button type="success" icon="el-icon-plus" size="small" @click="addListOpen" :disabled="!updataActive"
              style="background: #4EC880;border: none;">新增SKU
            </el-button>
          </el-col>
        </el-row>
        <el-col>
          <el-table :data="tableData" stripe style="width: 100%;text-align: left" border @row-click="myRowClick"
            :header-cell-style="{ color: 'black' }">
            <el-table-column prop="sku_code" label="SKU编码" sortable min-width="150"></el-table-column>
            <!--                    <el-table-column prop="value2" label="种类" width="200" sortable></el-table-column>-->
            <el-table-column prop="sku_name" label="SKU名称" class="Tnumber" sortable min-width="150"></el-table-column>
            <el-table-column prop="specification" label="规格" class="Tnumber" sortable min-width="150"></el-table-column>
            <el-table-column prop="textStatus" label="状态" class="Tnumber" sortable min-width="150"></el-table-column>
            <!--                    <el-table-column prop="unit_name" label="颜色"  ></el-table-column>-->
            <!--                    <el-table-column prop="unit_price" label="价格" width="200"></el-table-column>-->
            <!--                    <el-table-column prop="comments" label="备注" width="200"></el-table-column>-->
            <!--                    <el-table-column prop="value4" label="沟通时间" width="200" sortable></el-table-column>-->
            <!--                    <el-table-column prop="value5" label="状态" width="200" sortable></el-table-column>-->
            <!--                    <el-table-column prop="value6" label="字段名6" width="200" sortable></el-table-column>-->
            <!--                    <el-table-column prop="value7" label="字段名7" width="200" sortable></el-table-column>-->
            <!--                    <el-table-column prop="value8" label="字段名8" width="200" sortable></el-table-column>-->
            <!--                    <el-table-column prop="template_id" label="状态" width="140" ></el-table-column>-->
            <el-table-column label="操作" fixed="right" label-class-name="productSku_table_cell" width="100">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="myDetails(scope.$index, scope.row)">编辑 </el-button>
                <!--                            <el-button type="danger" size="mini" @click="deleteOpen2(scope.$index, scope.row)">删除</el-button>-->
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-row v-if="isProductType === 'TRIAL'">
        <el-row type="flex" align="middle">
          <el-col :span="16" style="font-size: 12px;color: #409EFF;margin-top:20px ">样品数：{{ tableTrial.length }}个
          </el-col>
          <el-col :span="8" style="text-align: end;">
            <el-button type="success" icon="el-icon-plus" size="small" @click="addTrialListOpen"
              :disabled="!updataActive" style="background: #4EC880;border: none;">新增样品
            </el-button>
          </el-col>
        </el-row>
        <el-col>
          <el-table :data="tableTrial" stripe style="width: 100%;text-align: left" border @row-click="myRowClick"
            :header-cell-style="{ color: 'black' }">
            <el-table-column prop="sku_code" label="样品编码" sortable min-width="150"></el-table-column>
            <el-table-column prop="sku_name" label="样品名称" class="Tnumber" sortable min-width="150"></el-table-column>
            <el-table-column prop="specification" label="规格" class="Tnumber" sortable min-width="150"></el-table-column>
            <el-table-column prop="textStatus" label="状态" class="Tnumber" sortable min-width="150"></el-table-column>
            <el-table-column label="操作" label-class-name="productSku_table_cell" fixed="right" width="100">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="myDetailsTrial(scope.$index, scope.row)">编辑 </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-row v-if="isProductType === 'COMPETITOR'">
        <el-row type="flex" align="middle">
          <el-col :span="16" style="font-size: 12px;color: #409EFF;margin-top:20px ">竞品数：{{ tableCompetitor.length }}个
          </el-col>
          <el-col :span="8" style="text-align: end;">
            <el-button type="success" icon="el-icon-plus" size="small" @click="addCompetitorListOpen"
              :disabled="!updataActive" style="background: #4EC880;border: none;">新增竞品
            </el-button>
          </el-col>
        </el-row>
        <el-col>
          <el-table :data="tableCompetitor" stripe style="width: 100%;text-align: left" border @row-click="myRowClick"
            :header-cell-style="{ color: 'black' }">
            <el-table-column prop="sku_code" label="竞品编码" sortable min-width="150"></el-table-column>
            <el-table-column prop="sku_name" label="竞品名称" class="Tnumber" sortable min-width="150"></el-table-column>
            <el-table-column prop="specification" label="规格" class="Tnumber" sortable min-width="150"></el-table-column>
            <el-table-column prop="textStatus" label="状态" class="Tnumber" sortable min-width="150"></el-table-column>
            <el-table-column label="操作" label-class-name="productSku_table_cell" fixed="right" width="100">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="myDetailsCompetitor(scope.$index, scope.row)">编辑
                </el-button>
                <!--                            <el-button type="danger" size="mini" @click="deleteOpen2(scope.$index, scope.row)">删除</el-button>-->
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>

    <!--添加产品-->
    <el-dialog title="" :visible.sync="dialogFormVisible" width="40%">
      <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
        <span style="color: #3998F7;font-size: 22px;padding-top: 5px">新增品类</span>
        <span>
          <el-button @click="submitForm" type="primary" size="small">保存</el-button>
          <el-button type="danger" @click="unopen" size="small">取消</el-button>
        </span>
      </div>
      <el-form :model="form" :rules="rules" ref="ruleForm" class="demo-ruleForm"
        style="padding-right: 60px;margin-left: 60px" hide-required-asterisk>
        <el-form-item label="名称" label-width="80px" prop="product_name" class="productSku_star">
          <el-input v-model="form.product_name"></el-input>
        </el-form-item>
        <el-form-item label="编码" label-width="80px" prop="product_code" class="productSku_star">
          <el-input v-model="form.product_code"></el-input>
        </el-form-item>
        <el-form-item label="有效" label-width="80px">
          <el-switch v-model="productStatusCreate" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
        </el-form-item>
        <!--                <el-form-item label="产品类别" label-width="120px">-->
        <!--                     <el-input v-model="form.category"></el-input>-->
        <!--                 </el-form-item>-->
        <!--                <el-form-item label="产品品牌" label-width="120px">-->
        <!--                     <el-input v-model="form.brand"></el-input>-->
        <!--                 </el-form-item>-->
        <!--                <el-form-item label="产品备注" label-width="120px">-->
        <!--                     <el-input v-model="form.comments"  type="textarea"></el-input>-->
        <!--                 </el-form-item>-->
        <!-- <el-form-item :label="judge(key)" label-width="120px" v-for="(item,key) in form" :key="key">
                     <el-input :type=" judgeType(key)" v-model="form[key]" :maxlength="200"></el-input>
                 </el-form-item>-->
        <!--<el-button type="success" icon="el-icon-plus" size="mini" @click="addExplain(form)" style="margin-left: 85%">添加说明</el-button>-->
      </el-form>
    </el-dialog>

    <!--产品详情-->
    <el-dialog title="" :visible.sync="dialogFormVisible2" id="productDetails" width="50%">
      <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
        <span style="color: #3998F7;font-size: 22px;padding-top: 5px">品类详情</span>
        <span>
          <el-button @click="submitForm2" type="primary" size="small">保存</el-button>
          <el-button type="danger" @click="unopen2" size="small">取消</el-button>
        </span>
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="基本信息" name="first">
          <el-form :model="upForm" :rules="rules2" ref="ruleForm2" class="demo-ruleForm" style="padding-right: 100px"
            hide-required-asterisk>
            <el-row>
              <el-col :span="12">
                <el-form-item label="品类编码" label-width="120px" prop="product_code" class="productSku_star">
                  <el-input v-model="upForm.product_code"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="品类名称" label-width="120px" prop="product_name" class="productSku_star">
                  <el-input v-model="upForm.product_name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="启用" label-width="120px">
                  <el-switch v-model="productStatus" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
                </el-form-item>
              </el-col>
            </el-row>

            <!--                <el-form-item label="产品类别" label-width="120px">-->
            <!--                    <el-input v-model="upForm.category"></el-input>-->
            <!--                </el-form-item>-->
            <!--                <el-form-item label="产品品牌" label-width="120px">-->
            <!--                    <el-input v-model="upForm.brand"></el-input>-->
            <!--                </el-form-item>-->
            <!--                <el-form-item label="产品备注" label-width="120px">-->
            <!--                    <el-input v-model="upForm.comments" type="textarea"></el-input>-->
            <!--                </el-form-item>-->
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="扩展信息" name="second">
          <div class="subjectList">
            <el-form hide-required-asterisk :ref="'list' + j" label-width="120px" v-for="(item, j) in extendedInfo"
              :model="extendedInfo[j]" :key="item.field_id">
              <el-col :span="item.input_type == 'COMMENTS' ? 24 : 12" v-if="item.input_type == 'TEXT'">
                <el-form-item :label="item.label" class="productSku_star" prop="field_value"
                  :rules="item.mandatory == 'T' ? [{ required: true, message: item.label + '不能为空' }] : []">
                  <el-input v-model="item.field_value" placeholder="请输入文本" :disabled="item.readonly == 'T'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="item.input_type == 'COMMENTS' ? 24 : 12" v-else-if="item.input_type == 'NUMBER'">
                <el-form-item :label="item.label" class="productSku_star" prop="field_value"
                  :rules="item.mandatory == 'T' ? [{ required: true, message: item.label + '不能为空' }] : []">
                  <el-input v-model="item.field_value" placeholder="请输入数字" type="number"
                    :disabled="item.readonly == 'T'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="item.input_type == 'COMMENTS' ? 24 : 12" v-else-if="item.input_type == 'DATE'">
                <el-form-item :label="item.label" class="productSku_star" prop="field_value"
                  :rules="item.mandatory == 'T' ? [{ required: true, message: item.label + '不能为空' }] : []">
                  <el-date-picker v-model="item.field_value" type="date" placeholder="选择日期时间" style="width: 100%"
                    format="yyyy-MM-dd" value-format="yyyy-MM-dd" :disabled="item.readonly == 'T'">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="item.input_type == 'COMMENTS' ? 24 : 12" v-else-if="item.input_type == 'TRUE-FALSE'">
                <el-form-item :label="item.label">
                  <el-switch v-model="item.field_value" active-color="#13ce66" active-value="T" inactive-value="F"
                    :disabled="item.readonly == 'T'">
                  </el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="item.input_type == 'COMMENTS' ? 24 : 12" v-else-if="item.input_type == 'LIST'">
                <el-form-item :label="item.label" class="productSku_star" prop="field_value"
                  :rules="item.mandatory == 'T' ? [{ required: true, message: item.label + '不能为空' }] : []">
                  <el-select v-model="item.field_value" :multiple="item.multiple == 'T'" placeholder="请选择"
                    style="width: 100%" :disabled="item.readonly == 'T'">
                    <el-option v-for="item in item.listArray" :key="item.key" :label="item.value1" :value="item.key">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="item.input_type == 'COMMENTS' ? 24 : 12" v-else>
                <el-form-item :label="item.label" class="productSku_star" prop="field_value"
                  :rules="item.mandatory == 'T' ? [{ required: true, message: item.label + '不能为空' }] : []">
                  <el-input :rows="3" v-model="item.field_value" placeholder="请输入备注信息" type="textarea"
                    :disabled="item.readonly == 'T'"></el-input>
                </el-form-item>
              </el-col>
            </el-form>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>

    <!--添加选项-->
    <el-dialog title="" :visible.sync="dialogFormVisible3">
      <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
        <span style="color: #3998F7;font-size: 22px;padding-top: 5px">添加SKU</span>
        <span>
          <el-button @click="submitForm3" type="primary" size="small">保存</el-button>
          <el-button type="danger" @click="unopen3" size="small">取消</el-button>
        </span>
      </div>
      <el-form :model="addListForm" :rules="rules3" ref="ruleForm3" class="demo-ruleForm"
        style="padding-right: 60px;margin-left:60px" hide-required-asterisk>
        <el-form-item label="名称" label-width="120px" prop="sku_name" class="productSku_star">
          <el-input v-model="addListForm.sku_name"></el-input>
        </el-form-item>
        <el-form-item label="编码" label-width="120px" prop="sku_code" class="productSku_star">
          <el-input v-model="addListForm.sku_code"></el-input>
        </el-form-item>
        <el-form-item label="商品规格" label-width="120px">
          <el-input v-model="addListForm.specification"></el-input>
        </el-form-item>
        <el-form-item label="生产企业" label-width="120px">
          <el-input v-model="addListForm.manufacturer"></el-input>
        </el-form-item>
        <el-form-item label="剂型" label-width="120px">
          <el-select v-model="addListForm.dosage_form" clearable style="width: 100%">
            <el-option v-for="item in getDosageList" :key="item.key" :label="item.value1" :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="最小包装单位" label-width="120px">
          <el-input v-model="addListForm.unit_name"></el-input>
        </el-form-item>
        <el-form-item label="考核价" label-width="120px">
          <el-input v-model="addListForm.unit_price" type="number"></el-input>
        </el-form-item>
        <el-form-item label="启用" label-width="120px">
          <el-switch v-model="addListForm.status" active-color="#13ce66"> </el-switch>
        </el-form-item>
        <!--                <el-form-item :label="judge(key)" label-width="120px" v-for="(item,key) in addListForm.value"  :key="key" v-if="onOff(key)<valueArr.length">-->
        <!--                    <el-input  v-model="addListForm.value[key]" :maxlength="200"></el-input>-->
        <!--                </el-form-item>-->
        <!--                <el-form-item :label="addListForm.status?'有效':'无效'" label-width="120px">-->
        <!--                    <el-switch v-model="addListForm.status" active-color="#13ce66"></el-switch>-->
        <!--                </el-form-item>-->
        <!--                <el-button type="success" icon="el-icon-plus" size="mini" @click="addOptions(addListForm.value)" style="margin-left: 85%">添加字段名称</el-button>-->
      </el-form>
    </el-dialog>
    <!--添加样品-->
    <el-dialog title="" :visible.sync="dialogFormVisible3Trial">
      <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
        <span style="color: #3998F7;font-size: 22px;padding-top: 5px">添加样品</span>
        <span>
          <el-button @click="submitForm3Trial" type="primary" size="small">保存</el-button>
          <el-button type="danger" @click="unopen3Trial" size="small">取消</el-button>
        </span>
      </div>
      <el-form :model="addListFormTrial" :rules="rules3" ref="ruleForm3Trial" class="demo-ruleForm"
        hide-required-asterisk style="padding-right: 60px;margin-left:60px">
        <el-form-item label="名称" label-width="120px" prop="sku_name" class="productSku_star">
          <el-input v-model="addListFormTrial.sku_name"></el-input>
        </el-form-item>
        <el-form-item label="编码" label-width="120px" prop="sku_code" class="productSku_star">
          <el-input v-model="addListFormTrial.sku_code"></el-input>
        </el-form-item>
        <el-form-item label="商品规格" label-width="120px">
          <el-input v-model="addListFormTrial.specification"></el-input>
        </el-form-item>
        <el-form-item label="生产企业" label-width="120px">
          <el-input v-model="addListFormTrial.manufacturer"></el-input>
        </el-form-item>
        <el-form-item label="剂型" label-width="120px">
          <el-select v-model="addListFormTrial.dosage_form" clearable style="width: 100%">
            <el-option v-for="item in getDosageList" :key="item.key" :label="item.value1" :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="最小包装单位" label-width="120px">
          <el-input v-model="addListFormTrial.unit_name"></el-input>
        </el-form-item>
        <el-form-item label="考核价" label-width="120px">
          <el-input v-model="addListFormTrial.unit_price" type="number"></el-input>
        </el-form-item>
        <el-form-item label="启用" label-width="120px">
          <el-switch v-model="addListFormTrial.status" active-color="#13ce66"> </el-switch>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!--添加竞品-->
    <el-dialog title="" :visible.sync="dialogFormVisible3Competitor">
      <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
        <span style="color: #3998F7;font-size: 22px;padding-top: 5px">添加竞品</span>
        <span>
          <el-button @click="submitForm3Competitor" type="primary" size="small">保存</el-button>
          <el-button type="danger" @click="unopen3Competitor" size="small">取消</el-button>
        </span>
      </div>
      <el-form :model="addListFormCompetitor" :rules="rules3" ref="ruleForm3Competitor" class="demo-ruleForm"
        hide-required-asterisk style="padding-right: 60px;margin-left: 60px">
        <el-form-item label="名称" label-width="120px" prop="sku_name" class="productSku_star">
          <el-input v-model="addListFormCompetitor.sku_name"></el-input>
        </el-form-item>
        <el-form-item label="编码" label-width="120px" prop="sku_code" class="productSku_star">
          <el-input v-model="addListFormCompetitor.sku_code"></el-input>
        </el-form-item>
        <el-form-item label="商品规格" label-width="120px">
          <el-input v-model="addListFormCompetitor.specification"></el-input>
        </el-form-item>
        <el-form-item label="生产企业" label-width="120px">
          <el-input v-model="addListFormCompetitor.manufacturer"></el-input>
        </el-form-item>
        <el-form-item label="剂型" label-width="120px">
          <el-select v-model="addListFormCompetitor.dosage_form" clearable style="width: 100%">
            <el-option v-for="item in getDosageList" :key="item.key" :label="item.value1" :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="最小包装单位" label-width="120px">
          <el-input v-model="addListFormCompetitor.unit_name"></el-input>
        </el-form-item>
        <el-form-item label="考核价" label-width="120px">
          <el-input v-model="addListFormCompetitor.unit_price" type="number"></el-input>
        </el-form-item>
        <el-form-item label="启用" label-width="120px">
          <el-switch v-model="addListFormCompetitor.status" active-color="#13ce66"> </el-switch>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!--编辑选项-->
    <el-dialog title="" :visible.sync="dialogFormVisible4" id="productDetails1">
      <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
        <span style="color: #3998F7;font-size: 22px;padding-top:5px">SKU详情</span>
        <span>
          <el-button @click="submitForm4" type="primary" size="small">保 存</el-button>
          <el-button type="danger" @click="unopen4" size="small">取 消</el-button>
        </span>
      </div>
      <el-tabs v-model="activeName1">
        <el-tab-pane label="基本信息" name="first">
          <el-form :model="updataListForm" :rules="rules4" ref="ruleForm4" class="demo-ruleForm"
            style="padding-right: 100px" hide-required-asterisk>
            <el-row>
              <el-col :span="12">
                <el-form-item label="SKU编码" label-width="120px" prop="sku_code" class="productSku_star">
                  <el-input v-model="updataListForm.sku_code"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="SKU名称" label-width="120px" prop="sku_name" class="productSku_star">
                  <el-input v-model="updataListForm.sku_name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="商品规格" label-width="120px">
                  <el-input v-model="updataListForm.specification"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="生产企业" label-width="120px">
                  <el-input v-model="updataListForm.manufacturer"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="剂型" label-width="120px">
                  <el-select v-model="updataListForm.dosage_form" clearable style="width: 100%">
                    <el-option v-for="item in getDosageList" :key="item.key" :label="item.value1" :value="item.key">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="最小包装单位" label-width="120px">
                  <el-input v-model="updataListForm.unit_name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="考核价" label-width="120px">
                  <el-input v-model="updataListForm.unit_price" type="number"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="启用" label-width="120px">
                  <el-switch v-model="updataListForm.status" active-color="#13ce66"> </el-switch>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="扩展信息" name="second">
          <div class="subjectList" style="">
            <el-form hide-required-asterisk :ref="'skuList' + j" label-width="120px" v-for="(item, j) in extendedInfo1"
              :model="extendedInfo1[j]" :key="item.field_id">
              <el-col :span="item.input_type == 'COMMENTS' ? 24 : 12" v-if="item.input_type == 'TEXT'">
                <el-form-item :label="item.label" class="productSku_star" prop="field_value"
                  :rules="item.mandatory == 'T' ? [{ required: true, message: item.label + '不能为空' }] : []">
                  <el-input v-model="item.field_value" placeholder="请输入文本" :disabled="item.readonly == 'T'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="item.input_type == 'COMMENTS' ? 24 : 12" v-else-if="item.input_type == 'NUMBER'">
                <el-form-item :label="item.label" class="productSku_star" prop="field_value"
                  :rules="item.mandatory == 'T' ? [{ required: true, message: item.label + '不能为空' }] : []">
                  <el-input v-model="item.field_value" placeholder="请输入数字" type="number"
                    :disabled="item.readonly == 'T'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="item.input_type == 'COMMENTS' ? 24 : 12" v-else-if="item.input_type == 'DATE'">
                <el-form-item :label="item.label" class="productSku_star" prop="field_value"
                  :rules="item.mandatory == 'T' ? [{ required: true, message: item.label + '不能为空' }] : []">
                  <el-date-picker v-model="item.field_value" type="date" placeholder="选择日期时间" style="width: 100%"
                    format="yyyy-MM-dd" value-format="yyyy-MM-dd" :disabled="item.readonly == 'T'">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="item.input_type == 'COMMENTS' ? 24 : 12" v-else-if="item.input_type == 'TRUE-FALSE'">
                <el-form-item :label="item.label">
                  <el-switch v-model="item.field_value" active-color="#13ce66" active-value="T" inactive-value="F"
                    :disabled="item.readonly == 'T'">
                  </el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="item.input_type == 'COMMENTS' ? 24 : 12" v-else-if="item.input_type == 'LIST'">
                <el-form-item :label="item.label" class="productSku_star" prop="field_value"
                  :rules="item.mandatory == 'T' ? [{ required: true, message: item.label + '不能为空' }] : []">
                  <el-select v-model="item.field_value" :multiple="item.multiple == 'T'" placeholder="请选择"
                    style="width: 100%" :disabled="item.readonly == 'T'">
                    <el-option v-for="item in item.listArray" :key="item.key" :label="item.value1" :value="item.key">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="item.input_type == 'COMMENTS' ? 24 : 12" v-else>
                <el-form-item :label="item.label" class="productSku_star" prop="field_value"
                  :rules="item.mandatory == 'T' ? [{ required: true, message: item.label + '不能为空' }] : []">
                  <el-input :rows="3" v-model="item.field_value" placeholder="请输入备注信息" type="textarea"
                    :disabled="item.readonly == 'T'"></el-input>
                </el-form-item>
              </el-col>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane label="批号" name="three">
          <el-row>
            <el-col :span="14"> <el-input
                placeholder="请输入批号"
                v-model="search_batch_no"
                clearable>
              </el-input>
            </el-col>
            <el-col :span="10"><el-button @click="getSkuBatchNo" type="primary" style="margin-left: 10px">搜 索</el-button></el-col>
          </el-row>
          <el-table :data="tableBatchNo" border style="width: 100%;margin-bottom:20px;margin-top:10px;" height="300">
            <el-table-column prop="sku_code" label="SKU编码" width="200">
            </el-table-column>
            <el-table-column prop="institution_code" label="机构编码" width="200">
            </el-table-column>
            <el-table-column prop="institution_name" label="机构名称" width="200">
            </el-table-column>
            <el-table-column prop="batch_no" label="批号">
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <!--编辑选项-->
    <el-dialog title="" :visible.sync="dialogFormVisible4Trial" id="productDetails1Trial">
      <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
        <span style="color: #3998F7;font-size: 22px;padding-top: 5px">样品详情</span>
        <span>
          <el-button @click="submitForm4Trial" type="primary" size="small">保 存</el-button>
          <el-button type="danger" @click="unopen4Trial" size="small">取 消</el-button>
        </span>
      </div>
      <el-tabs v-model="activeName1Trial">
        <el-tab-pane label="基本信息" name="first">
          <el-form :model="updataListFormTrial" :rules="rules4" ref="ruleForm4Trial" class="demo-ruleForm"
            style="padding-right: 100px" hide-required-asterisk>
            <el-row>
              <el-col :span="12">
                <el-form-item label="样品编码" label-width="120px" prop="sku_code" class="productSku_star">
                  <el-input v-model="updataListFormTrial.sku_code"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="样品名称" label-width="120px" prop="sku_name" class="productSku_star">
                  <el-input v-model="updataListFormTrial.sku_name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="商品规格" label-width="120px">
                  <el-input v-model="updataListFormTrial.specification"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="生产企业" label-width="120px">
                  <el-input v-model="updataListFormTrial.manufacturer"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="剂型" label-width="120px">
                  <el-select v-model="updataListFormTrial.dosage_form" clearable style="width: 100%">
                    <el-option v-for="item in getDosageList" :key="item.key" :label="item.value1" :value="item.key">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="最小包装单位" label-width="120px">
                  <el-input v-model="updataListFormTrial.unit_name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="考核价" label-width="120px">
                  <el-input v-model="updataListFormTrial.unit_price" type="number"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="启用" label-width="120px">
                  <el-switch v-model="updataListFormTrial.status" active-color="#13ce66"> </el-switch>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="扩展信息" name="second">
          <div class="subjectList" style="">
            <el-form :ref="'trialList' + j" label-width="120px" v-for="(item, j) in extendedInfo1Trial"
              :model="extendedInfo1Trial[j]" :key="item.field_id">
              <el-col :span="item.input_type === 'COMMENTS' ? 24 : 12" v-if="item.input_type === 'TEXT'">
                <el-form-item :label="item.label" prop="field_value"
                  :rules="item.mandatory === 'T' ? [{ required: true, message: item.label + '不能为空' }] : []">
                  <el-input v-model="item.field_value" placeholder="请输入文本" :disabled="item.readonly === 'T'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="item.input_type === 'COMMENTS' ? 24 : 12" v-else-if="item.input_type === 'NUMBER'">
                <el-form-item :label="item.label" prop="field_value"
                  :rules="item.mandatory === 'T' ? [{ required: true, message: item.label + '不能为空' }] : []">
                  <el-input v-model="item.field_value" placeholder="请输入数字" type="number"
                    :disabled="item.readonly === 'T'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="item.input_type === 'COMMENTS' ? 24 : 12" v-else-if="item.input_type === 'DATE'">
                <el-form-item :label="item.label" prop="field_value"
                  :rules="item.mandatory === 'T' ? [{ required: true, message: item.label + '不能为空' }] : []">
                  <el-date-picker v-model="item.field_value" type="date" placeholder="选择日期时间" style="width: 100%"
                    format="yyyy-MM-dd" value-format="yyyy-MM-dd" :disabled="item.readonly === 'T'">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="item.input_type === 'COMMENTS' ? 24 : 12" v-else-if="item.input_type === 'TRUE-FALSE'">
                <el-form-item :label="item.label">
                  <el-switch v-model="item.field_value" active-color="#13ce66" active-value="T" inactive-value="F"
                    :disabled="item.readonly === 'T'">
                  </el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="item.input_type === 'COMMENTS' ? 24 : 12" v-else-if="item.input_type === 'LIST'">
                <el-form-item :label="item.label" prop="field_value"
                  :rules="item.mandatory === 'T' ? [{ required: true, message: item.label + '不能为空' }] : []">
                  <el-select v-model="item.field_value" :multiple="item.multiple === 'T'" placeholder="请选择"
                    style="width: 100%" :disabled="item.readonly === 'T'">
                    <el-option v-for="item in item.listArray" :key="item.key" :label="item.value1" :value="item.key">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="item.input_type === 'COMMENTS' ? 24 : 12" v-else>
                <el-form-item :label="item.label" prop="field_value"
                  :rules="item.mandatory === 'T' ? [{ required: true, message: item.label + '不能为空' }] : []">
                  <el-input :rows="3" v-model="item.field_value" placeholder="请输入备注信息" type="textarea"
                    :disabled="item.readonly === 'T'"></el-input>
                </el-form-item>
              </el-col>
            </el-form>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <!--编辑选项-->
    <el-dialog title="" :visible.sync="dialogFormVisible4Competitor" id="productDetails1Competitor">
      <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
        <span style="color: #3998F7;font-size: 22px;padding-top: 5px">竞品详情</span>
        <span>
          <el-button @click="submitForm4Competitor" type="primary" size="small">保 存</el-button>
          <el-button type="danger" @click="unopen4Competitor" size="small">取 消</el-button>
        </span>
      </div>
      <el-tabs v-model="activeName1Competitor">
        <el-tab-pane label="基本信息" name="first">
          <el-form :model="updataListFormCompetitor" :rules="rules4" ref="ruleForm4Competitor" hide-required-asterisk
            class="demo-ruleForm" style="padding-right: 100px">
            <el-row>
              <el-col :span="12">
                <el-form-item label="竞品编码" label-width="120px" prop="sku_code" class="productSku_star">
                  <el-input v-model="updataListFormCompetitor.sku_code"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="竞品名称" label-width="120px" prop="sku_name" class="productSku_star">
                  <el-input v-model="updataListFormCompetitor.sku_name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="商品规格" label-width="120px">
                  <el-input v-model="updataListFormCompetitor.specification"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="生产企业" label-width="120px">
                  <el-input v-model="updataListFormCompetitor.manufacturer"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="剂型" label-width="120px">
                  <el-select v-model="updataListFormCompetitor.dosage_form" clearable style="width: 100%">
                    <el-option v-for="item in getDosageList" :key="item.key" :label="item.value1" :value="item.key">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="最小包装单位" label-width="120px">
                  <el-input v-model="updataListFormCompetitor.unit_name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="考核价" label-width="120px">
                  <el-input v-model="updataListFormCompetitor.unit_price" type="number"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="启用" label-width="120px">
                  <el-switch v-model="updataListFormCompetitor.status" active-color="#13ce66"> </el-switch>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="扩展信息" name="second">
          <div class="subjectList" style="">
            <el-form :ref="'competitorList' + j" label-width="120px" v-for="(item, j) in extendedInfo1Competitor"
              :model="extendedInfo1Competitor[j]" :key="item.field_id" hide-required-asterisk>
              <el-col :span="item.input_type === 'COMMENTS' ? 24 : 12" v-if="item.input_type === 'TEXT'">
                <el-form-item :label="item.label" class="productSku_star" prop="field_value"
                  :rules="item.mandatory === 'T' ? [{ required: true, message: item.label + '不能为空' }] : []">
                  <el-input v-model="item.field_value" placeholder="请输入文本" :disabled="item.readonly === 'T'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="item.input_type === 'COMMENTS' ? 24 : 12" v-else-if="item.input_type === 'NUMBER'">
                <el-form-item :label="item.label" class="productSku_star" prop="field_value"
                  :rules="item.mandatory === 'T' ? [{ required: true, message: item.label + '不能为空' }] : []">
                  <el-input v-model="item.field_value" placeholder="请输入数字" type="number"
                    :disabled="item.readonly === 'T'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="item.input_type === 'COMMENTS' ? 24 : 12" v-else-if="item.input_type === 'DATE'">
                <el-form-item :label="item.label" class="productSku_star" prop="field_value"
                  :rules="item.mandatory === 'T' ? [{ required: true, message: item.label + '不能为空' }] : []">
                  <el-date-picker v-model="item.field_value" type="date" placeholder="选择日期时间" style="width: 100%"
                    format="yyyy-MM-dd" value-format="yyyy-MM-dd" :disabled="item.readonly === 'T'">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="item.input_type === 'COMMENTS' ? 24 : 12" v-else-if="item.input_type === 'TRUE-FALSE'">
                <el-form-item :label="item.label">
                  <el-switch v-model="item.field_value" active-color="#13ce66" active-value="T" inactive-value="F"
                    :disabled="item.readonly === 'T'">
                  </el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="item.input_type === 'COMMENTS' ? 24 : 12" v-else-if="item.input_type === 'LIST'">
                <el-form-item :label="item.label" class="productSku_star" prop="field_value"
                  :rules="item.mandatory === 'T' ? [{ required: true, message: item.label + '不能为空' }] : []">
                  <el-select v-model="item.field_value" :multiple="item.multiple === 'T'" placeholder="请选择"
                    style="width: 100%" :disabled="item.readonly === 'T'">
                    <el-option v-for="item in item.listArray" :key="item.key" :label="item.value1" :value="item.key">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="item.input_type === 'COMMENTS' ? 24 : 12" v-else>
                <el-form-item :label="item.label" class="productSku_star" prop="field_value"
                  :rules="item.mandatory === 'T' ? [{ required: true, message: item.label + '不能为空' }] : []">
                  <el-input :rows="3" v-model="item.field_value" placeholder="请输入备注信息" type="textarea"
                    :disabled="item.readonly === 'T'"></el-input>
                </el-form-item>
              </el-col>
            </el-form>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>

    <!--导入-->
    <el-dialog title="" :visible.sync="dialogVisible5" width="800px">
      <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
        <span style="color: #3998F7;font-size: 22px">数据导入导出</span>
        <span>
          <el-button type="danger" @click="closeModal2" size="small">关闭</el-button>
        </span>
      </div>
      <el-form ref="form" label-width="100px" :model="form" style="font-size: 14px;padding: 0 0 40px 25px">
        <!--        品类-->
        <el-row style="height: 30px">
          <el-col :span="4" style="line-height:30px;font-weight: bold">下载现有数据</el-col>
          <el-col :span="3" style="line-height:30px">
            <el-button type="primary" size="mini" @click="xiazai('品类')">
              下载
            </el-button>
          </el-col>
          <el-col :span="12" style="padding-top: 8px;display: flex;align-items: center">
            <i class="el-icon-document" />
            产品 - 品类.xls
          </el-col>
        </el-row>
        <el-row style="height: 30px;margin-top: 10px">
          <el-col :span="4" style="line-height:30px;font-weight: bold">下载模板文件</el-col>
          <el-col :span="3" style="line-height:30px">
            <a style="text-decoration: none;color: #ffff;" class="el-button el-button--primary el-button--mini"
              href="../../../static/品类数据导入模版.xlsx" download="品类数据导入模版.xlsx">下载</a>
          </el-col>
          <el-col :span="16" style="padding-top: 8px;display: flex;align-items: center">
            <i class="el-icon-document" />
            品类数据导入模版.xls
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px;margin-bottom: 30px">
          <el-col :span="4" style="line-height:30px;font-weight: bold">
            上传数据
          </el-col>
          <el-col :span="10" style="margin-top:3px">
            <div style="border: 1px solid #ededed;height: 30px;">
              <span style="position: relative;top:8px;left:5px">{{ file1 }}</span>
            </div>
          </el-col>
          <el-col :span="8" style="margin-top: 3px;margin-left:20px">
            <el-upload class="upload-demo" ref="upload1" accept=".xlsx,.xls" action="" :file-list="fileList1"
              :show-file-list="false" :on-change="handleChange1" :limit="1" :auto-upload="false">
              <el-button slot="trigger" size="small"
                style="background-color: #7ed321;border: 1px solid #7ed321;color: white">选择文件
              </el-button>
              <el-button style="margin-left: 10px;" size="small" type="warning" @click="imortDataClick1">导入数据
              </el-button>
            </el-upload>
          </el-col>
        </el-row>
        <!--        SKU-->
        <el-row style="height: 30px">
          <el-col :span="4" style="line-height:30px;font-weight: bold">下载现有数据</el-col>
          <el-col :span="3" style="line-height:30px">
            <el-button type="primary" size="mini" @click="xiazai('SKU')">
              下载
            </el-button>
          </el-col>
          <el-col :span="12" style="padding-top: 8px;display: flex;align-items: center">
            <i class="el-icon-document" />
            产品 - SKU.xls
          </el-col>
        </el-row>
        <el-row style="height: 30px;margin-top: 10px">
          <el-col :span="4" style="line-height:30px;font-weight: bold">下载模板文件</el-col>
          <el-col :span="3" style="line-height:30px">
            <a style="text-decoration: none;color: #ffff;" class="el-button el-button--primary el-button--mini"
              href="../../../static/SKU数据导入模版.xlsx" download="SKU数据导入模版.xlsx">下载</a>
          </el-col>
          <el-col :span="16" style="padding-top: 8px;display: flex;align-items: center">
            <i class="el-icon-document" />
            SKU数据导入模版.xls
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px;margin-bottom: 30px">
          <el-col :span="4" style="line-height:30px;font-weight: bold">
            上传数据
          </el-col>
          <el-col :span="10" style="margin-top:3px">
            <div style="border: 1px solid #ededed;height: 30px;">
              <span style="position: relative;top:8px;left:5px">{{ file }}</span>
            </div>
          </el-col>
          <el-col :span="8" style="margin-top: 3px;margin-left:20px">
            <el-upload class="upload-demo" ref="upload" accept=".xlsx,.xls" action="" :file-list="fileList"
              :show-file-list="false" :on-change="handleChange" :limit="1" :auto-upload="false">
              <el-button slot="trigger" size="small"
                style="background-color: #7ed321;border: 1px solid #7ed321;color: white">选择文件
              </el-button>
              <el-button style="margin-left: 10px;" size="small" type="warning" @click="imortDataClick">导入数据
              </el-button>
            </el-upload>
          </el-col>
        </el-row>
        <!--        样品-->
        <el-row style="height: 30px">
          <el-col :span="4" style="line-height:30px;font-weight: bold">下载现有数据</el-col>
          <el-col :span="3" style="line-height:30px">
            <el-button type="primary" size="mini" @click="xiazai('样品')">
              下载
            </el-button>
          </el-col>
          <el-col :span="12" style="padding-top: 8px;display: flex;align-items: center">
            <i class="el-icon-document" />
            产品 - 样品.xls
          </el-col>
        </el-row>
        <el-row style="height: 30px;margin-top: 10px">
          <el-col :span="4" style="line-height:30px;font-weight: bold">下载模板文件</el-col>
          <el-col :span="3" style="line-height:30px">
            <a style="text-decoration: none;color: #ffff;" class="el-button el-button--primary el-button--mini"
              href="../../../static/样品数据导入模版.xlsx" download="样品数据导入模版.xlsx">下载</a>
          </el-col>
          <el-col :span="16" style="padding-top: 8px;display: flex;align-items: center">
            <i class="el-icon-document" />
            样品数据导入模版.xls
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px;margin-bottom: 30px">
          <el-col :span="4" style="line-height:30px;font-weight: bold">
            上传数据
          </el-col>
          <el-col :span="10" style="margin-top:3px">
            <div style="border: 1px solid #ededed;height: 30px;">
              <span style="position: relative;top:8px;left:5px">{{ file2 }}</span>
            </div>
          </el-col>
          <el-col :span="8" style="margin-top: 3px;margin-left:20px">
            <el-upload class="upload-demo" ref="upload2" accept=".xlsx,.xls" action="" :file-list="fileList2"
              :show-file-list="false" :on-change="handleChange2" :limit="1" :auto-upload="false">
              <el-button slot="trigger" size="small"
                style="background-color: #7ed321;border: 1px solid #7ed321;color: white">选择文件
              </el-button>
              <el-button style="margin-left: 10px;" size="small" type="warning" @click="imortDataClick2">导入数据
              </el-button>
            </el-upload>
          </el-col>
        </el-row>
        <!--        竞品-->
        <el-row style="height: 30px">
          <el-col :span="4" style="line-height:30px;font-weight: bold">下载现有数据</el-col>
          <el-col :span="3" style="line-height:30px">
            <el-button type="primary" size="mini" @click="xiazai('竞品')">
              下载
            </el-button>
          </el-col>
          <el-col :span="12" style="padding-top: 8px;display: flex;align-items: center">
            <i class="el-icon-document" />
            产品 - 竞品.xls
          </el-col>
        </el-row>
        <el-row style="height: 30px;margin-top: 10px">
          <el-col :span="4" style="line-height:30px;font-weight: bold">下载模板文件</el-col>
          <el-col :span="3" style="line-height:30px">
            <a style="text-decoration: none;color: #ffff;" class="el-button el-button--primary el-button--mini"
              href="../../../static/竞品数据导入模版.xlsx" download="竞品数据导入模版.xlsx">下载</a>
          </el-col>
          <el-col :span="16" style="padding-top: 8px;display: flex;align-items: center">
            <i class="el-icon-document" />
            竞品数据导入模版.xls
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px;margin-bottom: 30px">
          <el-col :span="4" style="line-height:30px;font-weight: bold">
            上传数据
          </el-col>
          <el-col :span="10" style="margin-top:3px">
            <div style="border: 1px solid #ededed;height: 30px;">
              <span style="position: relative;top:8px;left:5px">{{ file3 }}</span>
            </div>
          </el-col>
          <el-col :span="8" style="margin-top: 3px;margin-left:20px">
            <el-upload class="upload-demo" ref="upload3" accept=".xlsx,.xls" action="" :file-list="fileList3"
              :show-file-list="false" :on-change="handleChange3" :limit="1" :auto-upload="false">
              <el-button slot="trigger" size="small"
                style="background-color: #7ed321;border: 1px solid #7ed321;color: white">选择文件
              </el-button>
              <el-button style="margin-left: 10px;" size="small" type="warning" @click="imortDataClick3">导入数据
              </el-button>
            </el-upload>
          </el-col>
        </el-row>

        <!--        批号-->
        <el-row style="height: 30px">
          <el-col :span="4" style="line-height:30px;font-weight: bold">下载现有数据</el-col>
          <el-col :span="3" style="line-height:30px">
            <el-button type="primary" size="mini" @click="xiazai('批号')">
              下载
            </el-button>
          </el-col>
          <el-col :span="12" style="padding-top: 8px;display: flex;align-items: center">
            <i class="el-icon-document" />
            产品 - 批号.xls
          </el-col>
        </el-row>
        <el-row style="height: 30px;margin-top: 10px">
          <el-col :span="4" style="line-height:30px;font-weight: bold">下载模板文件</el-col>
          <el-col :span="3" style="line-height:30px">
            <a style="text-decoration: none;color: #ffff;" class="el-button el-button--primary el-button--mini"
              href="../../../static/批号数据导入模版.xlsx" download="批号数据导入模版.xlsx">下载</a>
          </el-col>
          <el-col :span="16" style="padding-top: 8px;display: flex;align-items: center">
            <i class="el-icon-document" />
            批号数据导入模版.xls
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px;margin-bottom: 30px">
          <el-col :span="4" style="line-height:30px;font-weight: bold">
            上传数据
          </el-col>
          <el-col :span="10" style="margin-top:3px">
            <div style="border: 1px solid #ededed;height: 30px;">
              <span style="position: relative;top:8px;left:5px">{{ file4 }}</span>
            </div>
          </el-col>
          <el-col :span="8" style="margin-top: 3px;margin-left:20px">
            <el-upload class="upload-demo" ref="upload4" accept=".xlsx,.xls" action="" :file-list="fileList4"
              :show-file-list="false" :on-change="handleChange4" :limit="1" :auto-upload="false">
              <el-button slot="trigger" size="small"
                style="background-color: #7ed321;border: 1px solid #7ed321;color: white">选择文件
              </el-button>
              <el-button style="margin-left: 10px;" size="small" type="warning" @click="imortDataClick4">导入数据
              </el-button>
            </el-upload>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
    <!--   错误提示品类 -->
    <el-dialog :visible.sync="showModal_a" :show-close="false" width="900px" style="margin-top: -20px;">
      <div slot="title">
        <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
          <span style="color: #3998F7;font-size: 22px">错误提示</span>
          <span>
            <el-button type="primary" size="small" @click="downloadError1">下载错误信息</el-button>
            <el-button type="danger" size="small" @click="showModal_a = false">关闭</el-button>
          </span>
        </div>
      </div>
      <el-table border :data="errorData1" stripe height="450px" style="width: 100%;margin-top: -20px;"
        header-cell-class-name="headerStyle" :default-sort="{ prop: 'date', order: 'descending' }">
        <el-table-column type="index" :index="1" label="序号" style="font-size: 20px;color: #585757"
          width="75"></el-table-column>
        <el-table-column prop="product_code" label="品类编码" min-width="120px" sortable> </el-table-column>
        <el-table-column prop="product_name" label="品类名称" min-width="120px" sortable> </el-table-column>
        <el-table-column prop="status" label="是否启用" min-width="140" sortable> </el-table-column>
        <el-table-column fixed="right" label="报错信息" width="240px">
          <template slot-scope="scope">
            <div>
              <span style="font-size: 10px;color: red" v-html="scope.row.message.replace(/！/g, '！\<br\/\>')"></span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!--    错误提示SKU-->
    <el-dialog :visible.sync="showModal2" :show-close="false" width="900px" style="margin-top: -20px;">
      <div slot="title">
        <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
          <span style="color: #3998F7;font-size: 22px">错误提示</span>
          <span>
            <el-button type="primary" size="small" @click="downloadError">下载错误信息</el-button>
            <el-button type="danger" size="small" @click="showModal2 = false">关闭</el-button>
          </span>
        </div>
      </div>
      <el-table border :data="errorData" stripe height="450px" style="width: 100%;margin-top: -20px;"
        header-cell-class-name="headerStyle" :default-sort="{ prop: 'date', order: 'descending' }">
        <el-table-column type="index" :index="1" label="序号" style="font-size: 20px;color: #585757"
          width="75"></el-table-column>
        <el-table-column prop="product_code" label="品类编码" min-width="120px" sortable> </el-table-column>
        <el-table-column prop="product_name" label="品类名称" min-width="120px" sortable> </el-table-column>
        <el-table-column prop="sku_code" label="SKU编码" min-width="150" sortable> </el-table-column>
        <el-table-column prop="sku_name" label="SKU名称" min-width="100%" sortable> </el-table-column>
        <el-table-column prop="specification" label="商品规格" min-width="100%" sortable> </el-table-column>
        <el-table-column prop="manufacturer" label="生产企业" min-width="150%" sortable> </el-table-column>
        <el-table-column prop="dosage_form_name" label="剂型" min-width="100%" sortable> </el-table-column>
        <el-table-column prop="unit_name" label="最小包装单位" min-width="120" sortable> </el-table-column>
        <el-table-column prop="unit_price" label="考核价" min-width="120" sortable> </el-table-column>
        <el-table-column prop="status" label="是否启用" min-width="140" sortable> </el-table-column>
        <el-table-column fixed="right" label="报错信息" width="240px">
          <template slot-scope="scope">
            <div>
              <span style="font-size: 10px;color: red" v-html="scope.row.message.replace(/！/g, '！\<br\/\>')"></span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!--    错误提示样品-->
    <el-dialog :visible.sync="showModal_b" :show-close="false" width="900px" style="margin-top: -20px;">
      <div slot="title">
        <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
          <span style="color: #3998F7;font-size: 22px">错误提示</span>
          <span>
            <el-button type="primary" size="small" @click="downloadError2">下载错误信息</el-button>
            <el-button type="danger" size="small" @click="showModal_b = false">关闭</el-button>
          </span>
        </div>
      </div>
      <el-table border :data="errorData2" stripe height="450px" style="width: 100%;margin-top: -20px;"
        header-cell-class-name="headerStyle" :default-sort="{ prop: 'date', order: 'descending' }">
        <el-table-column type="index" :index="1" label="序号" style="font-size: 20px;color: #585757"
          width="75"></el-table-column>
        <el-table-column prop="product_code" label="品类编码" min-width="120px" sortable> </el-table-column>
        <el-table-column prop="product_name" label="品类名称" min-width="120px" sortable> </el-table-column>
        <el-table-column prop="sku_code" label="样品编码" min-width="150" sortable> </el-table-column>
        <el-table-column prop="sku_name" label="样品名称" min-width="100%" sortable> </el-table-column>
        <el-table-column prop="specification" label="商品规格" min-width="100%" sortable> </el-table-column>
        <el-table-column prop="manufacturer" label="生产企业" min-width="150%" sortable> </el-table-column>
        <el-table-column prop="dosage_form_name" label="剂型" min-width="100%" sortable> </el-table-column>
        <el-table-column prop="unit_name" label="最小包装单位" min-width="120" sortable> </el-table-column>
        <el-table-column prop="unit_price" label="考核价" min-width="120" sortable> </el-table-column>
        <el-table-column prop="status" label="是否启用" min-width="140" sortable> </el-table-column>
        <el-table-column fixed="right" label="报错信息" width="240px">
          <template slot-scope="scope">
            <div>
              <span style="font-size: 10px;color: red" v-html="scope.row.message.replace(/！/g, '！\<br\/\>')"></span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!--    错误提示竞品-->
    <el-dialog :visible.sync="showModal_c" :show-close="false" width="900px" style="margin-top: -20px;">
      <div slot="title">
        <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
          <span style="color: #3998F7;font-size: 22px">错误提示</span>
          <span>
            <el-button type="primary" size="small" @click="downloadError3">下载错误信息</el-button>
            <el-button type="danger" size="small" @click="showModal_c = false">关闭</el-button>
          </span>
        </div>
      </div>
      <el-table border :data="errorData3" stripe height="450px" style="width: 100%;margin-top: -20px;"
        header-cell-class-name="headerStyle" :default-sort="{ prop: 'date', order: 'descending' }">
        <el-table-column type="index" :index="1" label="序号" style="font-size: 20px;color: #585757"
          width="75"></el-table-column>
        <el-table-column prop="product_code" label="品类编码" min-width="120px" sortable> </el-table-column>
        <el-table-column prop="product_name" label="品类名称" min-width="120px" sortable> </el-table-column>
        <el-table-column prop="sku_code" label="竞品编码" min-width="150" sortable> </el-table-column>
        <el-table-column prop="sku_name" label="竞品名称" min-width="100%" sortable> </el-table-column>
        <el-table-column prop="specification" label="商品规格" min-width="100%" sortable> </el-table-column>
        <el-table-column prop="manufacturer" label="生产企业" min-width="150%" sortable> </el-table-column>
        <el-table-column prop="dosage_form_name" label="剂型" min-width="100%" sortable> </el-table-column>
        <el-table-column prop="unit_name" label="最小包装单位" min-width="120" sortable> </el-table-column>
        <el-table-column prop="unit_price" label="考核价" min-width="120" sortable> </el-table-column>
        <el-table-column prop="status" label="是否启用" min-width="140" sortable> </el-table-column>
        <el-table-column fixed="right" label="报错信息" width="240px">
          <template slot-scope="scope">
            <div>
              <span style="font-size: 10px;color: red" v-html="scope.row.message.replace(/！/g, '！\<br\/\>')"></span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!--    错误提示批号-->
    <el-dialog :visible.sync="showModal_d" :show-close="false" width="900px" style="margin-top: -20px;">
      <div slot="title">
        <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
          <span style="color: #3998F7;font-size: 22px">错误提示</span>
          <span>
            <el-button type="primary" size="small" @click="downloadError4">下载错误信息</el-button>
            <el-button type="danger" size="small" @click="showModal_d = false">关闭</el-button>
          </span>
        </div>
      </div>
      <el-table border :data="errorData4" stripe height="450px" style="width: 100%;margin-top: -20px;"
        header-cell-class-name="headerStyle" :default-sort="{ prop: 'date', order: 'descending' }">
        <el-table-column type="index" :index="1" label="序号" style="font-size: 20px;color: #585757"
          width="75"></el-table-column>
        <el-table-column prop="product_code" label="品类编码" min-width="120px" sortable> </el-table-column>
        <el-table-column prop="product_name" label="品类名称" min-width="120px" sortable> </el-table-column>
        <el-table-column prop="sku_code" label="竞品编码" min-width="150" sortable> </el-table-column>
        <el-table-column prop="sku_name" label="竞品名称" min-width="100%" sortable> </el-table-column>
        <el-table-column prop="specification" label="商品规格" min-width="100%" sortable> </el-table-column>
        <el-table-column prop="manufacturer" label="生产企业" min-width="150%" sortable> </el-table-column>
        <el-table-column prop="dosage_form_name" label="剂型" min-width="100%" sortable> </el-table-column>
        <el-table-column prop="unit_name" label="最小包装单位" min-width="120" sortable> </el-table-column>
        <el-table-column prop="unit_price" label="考核价" min-width="120" sortable> </el-table-column>
        <el-table-column prop="status" label="是否启用" min-width="140" sortable> </el-table-column>
        <el-table-column fixed="right" label="报错信息" width="240px">
          <template slot-scope="scope">
            <div>
              <span style="font-size: 10px;color: red" v-html="scope.row.message.replace(/！/g, '！\<br\/\>')"></span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import http from '../../APIService/http'
import { MessageBox, Message } from 'element-ui'
import xlsx from 'xlsx'
import { export_json_to_excel } from '../../vendor/Export2Excel'
import axios from 'axios'

let number = 1
export default {
  name: 'Main',
  data() {
    return {
      excelData: [],
      excelData1: [],
      excelData2: [],
      excelData3: [],
      excelData4: [],
      loadingText: '',
      loading: false,
      record: [],
      errData: '',
      errData1: '',
      errData2: '',
      errData3: '',
      errData4: '',
      errorData: [],
      errorData1: [],
      errorData2: [],
      errorData3: [],
      errorData4: [],
      isProductType: 'SKU',
      sku_id: '',
      sku_idTrial: '',
      sku_idCompetitor: '',
      product_id: '',
      extendedInfo: [],
      extendedInfo1: [],
      extendedInfo1Trial: [],
      extendedInfo1Competitor: [],
      activeName: 'first',
      activeName1: 'first',
      activeName1Trial: 'first',
      activeName1Competitor: 'first',
      file: '',
      file1: '',
      file2: '',
      file3: '',
      file4: '',
      showModal2: false,
      showModal_a: false,
      showModal_b: false,
      showModal_c: false,
      showModal_d: false,
      fileList: [],
      fileList1: [],
      fileList2: [],
      fileList3: [],
      fileList4: [],
      addUserDis: false,
      productStatusCreate: true,
      productStatus: false,
      dataNode: '',
      nodeData: '',
      per: 0,
      listDate: {
        dictionary_id: '',
        tenant_id: '',
      },
      MyData: '',
      define_id: '',
      len: 0,
      len2: 0,
      updataActive: '',
      stateNum: 1,
      optionsNum: 1,
      form: {
        product_name: '',
        product_code: '',
        comments: '',
        category: '',
        brand: '',
        status: '',
      },
      rules: {
        product_name: [{ required: true, message: '请输入品类名称', trigger: 'blur' }],
        product_code: [{ required: true, message: '请输入品类编码', trigger: 'blur' }],
      },
      upForm: {
        product_name: '',
        product_code: '',
        comments: '',
        category: '',
        brand: '',
      },
      rules2: {
        product_name: [{ required: true, message: '请输入品类名称', trigger: 'blur' }],
        product_code: [{ required: true, message: '请输入品类编码', trigger: 'blur' }],
      },
      valueArr: [],
      addListForm: {
        sku_name: '',
        sku_code: '',
        specification: '',
        unit_name: '',
        unit_price: '',
        comments: '',
        for_sale: 'F',
        for_free: 'F',
        status: true,
        manufacturer: '',
        dosage_form: '',
      },
      addListFormTrial: {
        sku_name: '',
        sku_code: '',
        specification: '',
        unit_name: '',
        unit_price: '',
        comments: '',
        for_sale: 'F',
        for_free: 'F',
        status: true,
        manufacturer: '',
        dosage_form: '',
      },
      addListFormCompetitor: {
        sku_name: '',
        sku_code: '',
        specification: '',
        unit_name: '',
        unit_price: '',
        comments: '',
        for_sale: 'F',
        for_free: 'F',
        status: true,
        manufacturer: '',
        dosage_form: '',
      },
      rules3: {
        sku_name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        sku_code: [{ required: true, message: '请输入编码', trigger: 'blur' }],
      },
      updataListForm: {
        sku_name: '',
        sku_code: '',
        specification: '',
        unit_name: '',
        unit_price: '',
        comments: '',
        for_sale: 'F',
        for_free: 'F',
        dosage_form: '',
        manufacturer: '',
      },
      updataListFormTrial: {
        sku_name: '',
        sku_code: '',
        specification: '',
        unit_name: '',
        unit_price: '',
        comments: '',
        for_sale: 'F',
        for_free: 'F',
        dosage_form: '',
        manufacturer: '',
      },
      updataListFormCompetitor: {
        sku_name: '',
        sku_code: '',
        specification: '',
        unit_name: '',
        unit_price: '',
        comments: '',
        for_sale: 'F',
        for_free: 'F',
        dosage_form: '',
        manufacturer: '',
      },
      rules4: {
        sku_name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        sku_code: [{ required: true, message: '请输入编码', trigger: 'blur' }],
      },
      treeId: '',
      dialogFormVisible: false,
      dialogFormVisible2: false,
      dialogFormVisible3: false,
      dialogFormVisible3Trial: false,
      dialogFormVisible3Competitor: false,
      dialogFormVisible4: false,
      dialogFormVisible4Trial: false,
      dialogFormVisible4Competitor: false,
      dialogVisible5: false,
      folderId: null,
      folderName: null,
      num: {
        sum: 0,
      },
      myactive1: false,
      myactive2: false,
      schTitle1: '',
      schTitle1Code: '',
      treeKey: '',
      //表格数据
      tableData: [],
      tableTrial: [],
      tableCompetitor: [],
      tableBatchNo:[],
      search_batch_no:"",
      filterText: '',
      compileDic: {
        category: '',
        old_category: '',
        tenant_id: '',
        define_id: '',
      },
      data: [
        { label: '已启用', children: [] },
        { label: '已停用', children: [] },
      ],
      defaultProps: {
        label: 'label',
      },
      getDosageList: [],
      Mechanism: [],
      arr: [],
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    },
  },
  created() {
    this.getLibrary('FirstRefresh')
    this.getDosage()
  },

  methods: {
    xiazai(type) {
      if (type === 'SKU') {
        this.exportProductSku(type)
      }
      if (type === '样品') {
        this.exportProductTrial(type)
      }
      if (type === '竞品') {
        this.exportProductCompetitor(type)
      }
      if (type === '品类') {
        this.exportProduct(type)
      }
      if (type === '批号') {
        this.exportProductBatch(type)
      }
    },
    //导出品类列表
    async exportProduct(type) {
      this.loading = true
      await axios({
        method: 'post',
        url: '/wapi/derive/exportProduct',
        data: {
          tenant_id: this.$store.getters.getUser.tenant_id,
        },
        responseType: 'arraybuffer',
      }).then((res) => {
        // if (res.status == 200 && res.data.size) {
        // var uInt8Array = new Uint8Array(res); //先将返回的二进制数组转化为js的二进制数组
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' }) //然后创建blob对象，文件类型设置为excel的类型

        const fileName = type + '列表.xlsx'

        const elink = document.createElement('a')
        elink.download = fileName
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href) // 释放URL 对象
        document.body.removeChild(elink)
        // } else {
        //   this.$message.error('下载失败')
        // }
        this.loading = false
      })
    },
    //导出sku列表
    async exportProductSku(type) {
      this.loading = true
      await axios({
        method: 'post',
        url: '/wapi/derive/exportProductSku',
        data: {
          tenant_id: this.$store.getters.getUser.tenant_id,
        },
        // responseType: 'arraybuffer'
        responseType: 'arraybuffer',
      }).then((res) => {
        // if (res.status == 200 && res.data.size) {
        // var uInt8Array = new Uint8Array(res); //先将返回的二进制数组转化为js的二进制数组
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' }) //然后创建blob对象，文件类型设置为excel的类型

        const fileName = type + '列表.xlsx'

        const elink = document.createElement('a')
        elink.download = fileName
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href) // 释放URL 对象
        document.body.removeChild(elink)
        // } else {
        //   this.$message.error('下载失败')
        // }
        this.loading = false
      })
    },
    //导出样品列表
    async exportProductTrial(type) {
      this.loading = true
      await axios({
        method: 'post',
        url: '/wapi/derive/exportProductTrial',
        data: {
          tenant_id: this.$store.getters.getUser.tenant_id,
        },
        responseType: 'arraybuffer',
      }).then((res) => {
        // if (res.status == 200 && res.data.size) {
        // var uInt8Array = new Uint8Array(res); //先将返回的二进制数组转化为js的二进制数组
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' }) //然后创建blob对象，文件类型设置为excel的类型

        const fileName = type + '列表.xlsx'

        const elink = document.createElement('a')
        elink.download = fileName
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href) // 释放URL 对象
        document.body.removeChild(elink)
        // } else {
        //   this.$message.error('下载失败')
        // }
        this.loading = false
      })
    },
    //导出竞品列表
    async exportProductCompetitor(type) {
      this.loading = true
      await axios({
        method: 'post',
        url: '/wapi/derive/exportProductCompetitor',
        data: {
          tenant_id: this.$store.getters.getUser.tenant_id,
        },
        responseType: 'arraybuffer',
      }).then((res) => {
        // if (res.status == 200 && res.data.size) {
        // var uInt8Array = new Uint8Array(res); //先将返回的二进制数组转化为js的二进制数组
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' }) //然后创建blob对象，文件类型设置为excel的类型

        const fileName = type + '列表.xlsx'

        const elink = document.createElement('a')
        elink.download = fileName
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href) // 释放URL 对象
        document.body.removeChild(elink)
        // } else {
        //   this.$message.error('下载失败')
        // }
        this.loading = false
      })
    },

    //导出批号列表
    async exportProductBatch(type) {
      this.loading = true
      await axios({
        method: 'post',
        url: '/wapi/derive/exportProductSkuBatch',
        data: {
          tenant_id: this.$store.getters.getUser.tenant_id,
        },
        responseType: 'arraybuffer',
      }).then((res) => {
        // if (res.status == 200 && res.data.size) {
        // var uInt8Array = new Uint8Array(res); //先将返回的二进制数组转化为js的二进制数组
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' }) //然后创建blob对象，文件类型设置为excel的类型

        const fileName = type + '列表.xlsx'

        const elink = document.createElement('a')
        elink.download = fileName
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href) // 释放URL 对象
        document.body.removeChild(elink)
        // } else {
        //   this.$message.error('下载失败')
        // }
        this.loading = false
      })
    },
    obj_to_arr(names, data) {
      return data.map((item) => {
        let arr = []
        names.forEach((name) => {
          arr.push(item[name])
        })
        return arr
      })
    },
    downloadError() {
      try {
        this.loading = true
        let tHeader = [
          '品类编码',
          '品类名称',
          'SKU编码',
          'SKU名称',
          '商品规格',
          '生产企业',
          '剂型',
          '最小包装单位',
          '考核价',
          '是否启用',
          '报错信息',
        ]
        let names = [
          'product_code',
          'product_name',
          'sku_code',
          'sku_name',
          'specification',
          'manufacturer',
          'dosage_form_name',
          'unit_name',
          'unit_price',
          'status',
          'message',
        ]
        let data = this.obj_to_arr(names, this.errData)
        this.loadingText = `正在下载错误数据0% (0 / ${data.length})`
        this.downloadErrorExcel(tHeader, data, 0, 20000)
        //错误数据
        this.loading = false
        this.loadingText = '拼命加载中'
      } catch (err) {
        this.loading = false
        this.loadingText = '拼命加载中'
        this.$message.error('下载失败！')
      }
      // try {
      //   import('@/vendor/Export2Excel').then(excel => {
      //     const tHeader = ['科室编码','科室名称','排序','是否启用','备注','报错信息']
      //     const filterVal = [
      //       'dept_code',
      //       'dept_name',
      //       'sort',
      //       'status',
      //       'comments',
      //       'message'
      //     ]
      //     let arr=[...this.arr]
      //     for (var i = 0; i < arr.length; i++) {
      //       let obj = arr[i].message.join(" ")
      //       arr[i].message = obj
      //     }
      //     const list = arr
      //     const data = this.formatJson(filterVal, list)
      //     excel.export_json_to_excel({
      //       header: tHeader,
      //       data,
      //       filename: '报错信息表',
      //       autoWidth: this.autoWidth
      //     })
      //     this.loading = false
      //     this.errorDialog = false
      //   })
      // } catch (err) {
      //   this.loading = false
      //   this.error()
      // }
    },
    downloadError1() {
      try {
        this.loading = true
        let tHeader = ['品类编码', '品类名称', '是否启用', '报错信息']
        let names = ['product_code', 'product_name', 'status', 'message']
        let data = this.obj_to_arr(names, this.errData1)
        this.loadingText = `正在下载错误数据0% (0 / ${data.length})`
        this.downloadErrorExcel(tHeader, data, 0, 20000)
        //错误数据
        this.loading = false
        this.loadingText = '拼命加载中'
      } catch (err) {
        this.loading = false
        this.loadingText = '拼命加载中'
        this.$message.error('下载失败！')
      }
      // try {
      //   import('@/vendor/Export2Excel').then(excel => {
      //     const tHeader = ['科室编码','科室名称','排序','是否启用','备注','报错信息']
      //     const filterVal = [
      //       'dept_code',
      //       'dept_name',
      //       'sort',
      //       'status',
      //       'comments',
      //       'message'
      //     ]
      //     let arr=[...this.arr]
      //     for (var i = 0; i < arr.length; i++) {
      //       let obj = arr[i].message.join(" ")
      //       arr[i].message = obj
      //     }
      //     const list = arr
      //     const data = this.formatJson(filterVal, list)
      //     excel.export_json_to_excel({
      //       header: tHeader,
      //       data,
      //       filename: '报错信息表',
      //       autoWidth: this.autoWidth
      //     })
      //     this.loading = false
      //     this.errorDialog = false
      //   })
      // } catch (err) {
      //   this.loading = false
      //   this.error()
      // }
    },
    downloadError2() {
      try {
        this.loading = true
        let tHeader = [
          '品类编码',
          '品类名称',
          '样品编码',
          '样品名称',
          '商品规格',
          '生产企业',
          '剂型',
          '最小包装单位',
          '考核价',
          '是否启用',
          '报错信息',
        ]
        let names = [
          'product_code',
          'product_name',
          'sku_code',
          'sku_name',
          'specification',
          'manufacturer',
          'dosage_form_name',
          'unit_name',
          'unit_price',
          'status',
          'message',
        ]
        let data = this.obj_to_arr(names, this.errData2)
        this.loadingText = `正在下载错误数据0% (0 / ${data.length})`
        this.downloadErrorExcel(tHeader, data, 0, 20000)
        //错误数据
        this.loading = false
        this.loadingText = '拼命加载中'
      } catch (err) {
        this.loading = false
        this.loadingText = '拼命加载中'
        this.$message.error('下载失败！')
      }
      // try {
      //   import('@/vendor/Export2Excel').then(excel => {
      //     const tHeader = ['科室编码','科室名称','排序','是否启用','备注','报错信息']
      //     const filterVal = [
      //       'dept_code',
      //       'dept_name',
      //       'sort',
      //       'status',
      //       'comments',
      //       'message'
      //     ]
      //     let arr=[...this.arr]
      //     for (var i = 0; i < arr.length; i++) {
      //       let obj = arr[i].message.join(" ")
      //       arr[i].message = obj
      //     }
      //     const list = arr
      //     const data = this.formatJson(filterVal, list)
      //     excel.export_json_to_excel({
      //       header: tHeader,
      //       data,
      //       filename: '报错信息表',
      //       autoWidth: this.autoWidth
      //     })
      //     this.loading = false
      //     this.errorDialog = false
      //   })
      // } catch (err) {
      //   this.loading = false
      //   this.error()
      // }
    },
    downloadError3() {
      try {
        this.loading = true
        let tHeader = [
          '品类编码',
          '品类名称',
          '竞品编码',
          '竞品名称',
          '商品规格',
          '生产企业',
          '剂型',
          '最小包装单位',
          '考核价',
          '是否启用',
          '报错信息',
        ]
        let names = [
          'product_code',
          'product_name',
          'sku_code',
          'sku_name',
          'specification',
          'manufacturer',
          'dosage_form_name',
          'unit_name',
          'unit_price',
          'status',
          'message',
        ]
        let data = this.obj_to_arr(names, this.errData3)
        this.loadingText = `正在下载错误数据0% (0 / ${data.length})`
        this.downloadErrorExcel(tHeader, data, 0, 20000)
        //错误数据
        this.loading = false
        this.loadingText = '拼命加载中'
      } catch (err) {
        this.loading = false
        this.loadingText = '拼命加载中'
        this.$message.error('下载失败！')
      }
      // try {
      //   import('@/vendor/Export2Excel').then(excel => {
      //     const tHeader = ['科室编码','科室名称','排序','是否启用','备注','报错信息']
      //     const filterVal = [
      //       'dept_code',
      //       'dept_name',
      //       'sort',
      //       'status',
      //       'comments',
      //       'message'
      //     ]
      //     let arr=[...this.arr]
      //     for (var i = 0; i < arr.length; i++) {
      //       let obj = arr[i].message.join(" ")
      //       arr[i].message = obj
      //     }
      //     const list = arr
      //     const data = this.formatJson(filterVal, list)
      //     excel.export_json_to_excel({
      //       header: tHeader,
      //       data,
      //       filename: '报错信息表',
      //       autoWidth: this.autoWidth
      //     })
      //     this.loading = false
      //     this.errorDialog = false
      //   })
      // } catch (err) {
      //   this.loading = false
      //   this.error()
      // }
    },
    downloadError4() {
      try {
        this.loading = true
        let tHeader = [
          '产品编码',
          '机构编码',
          '批号',
          '报错信息',
        ]
        let names = [
          'sku_code',
          'institution_code',
          'batch_no',
          'message',
        ]
        let data = this.obj_to_arr(names, this.errData4)
        this.loadingText = `正在下载错误数据0% (0 / ${data.length})`
        this.downloadErrorExcel(tHeader, data, 0, 20000)
        //错误数据
        this.loading = false
        this.loadingText = '拼命加载中'
      } catch (err) {
        this.loading = false
        this.loadingText = '拼命加载中'
        this.$message.error('下载失败！')
      }
    },
    downloadErrorExcel(header, data, page = 0, limit = 5000) {
      try {
        if (page * limit >= data.length) {
          return true
        }

        //错误数据
        let tHeader = header
        let tData = data.slice(page * limit, (page + 1) * limit)
        export_json_to_excel({
          header: tHeader,
          data: tData,
          filename: '报错信息表' + (!page ? '' : page),
        })
        this.loadingText = `正在下载错误数据0% (${(page + 1) * limit} / ${data.length})`
        this.downloadErrorExcel(header, data, page + 1, limit)
      } catch (err) {
        this.loading = false
        this.loadingText = '拼命加载中'
        this.$message.error('下载失败！')
      }
    },
    handleExportData() {
      try {
        import('@/vendor/Export2Excel').then((excel) => {
          const tHeader = [
            '品类编码',
            '品类名称',
            'SKU编码',
            'SKU名称',
            '商品规格',
            '生产企业',
            '剂型编码',
            '剂型',
            '最小包装单位',
            '考核价',
            '报错信息',
          ]
          const filterVal = [
            'product_code',
            'product_name',
            'sku_code',
            'sku_name',
            'specification',
            'manufacturer',
            'dosage_form',
            'dosage_form_name',
            'unit_name',
            'unit_price',
            'message',
          ]
          let arr = [...this.arr]
          for (var i = 0; i < arr.length; i++) {
            let obj = arr[i].message.join(' ')
            arr[i].message = obj
          }

          const list = arr
          const data = this.formatJson(filterVal, list)

          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: '报错信息表',
            autoWidth: this.autoWidth,
          })
        })
        this.loading = false
        this.showModal2 = false
      } catch (err) {
        this.loading = false
        this.error()
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]))
    },
    async imortDataClick() {
      if (this.excelData.length === 0) {
        this.$message.error('请选择导入模板！')
        return false
      }
      this.loading = true
      this.loadingText = `正在导入数据0%(0/${this.excelData.length - 1})`
      this.errData = ''
      this.record = []
      let herder = this.excelData[0]
      let res = await this.importData(herder, this.excelData.slice(1), 0, 500, this.excelData.length - 1)

      if (!res) {
        this.$message.error('导入失败')
        this.loading = false
        this.loadingText = '拼命加载中'
      } else {
        if (this.record.some((item) => item)) {
          this.$message.success('导入成功')
          this.loadingText = '拼命加载中'
          this.loading = false
          if (this.errData.length > 0) {
            this.showModal2 = true
            this.errorData = this.errData.slice(0, 100)
          }
        } else {
          this.$message.error('导入失败')
          this.loading = false
          this.loadingText = '拼命加载中'
        }
      }
      // if (this.isUpload) {
      //   this.$refs.upload.submit()
      // } else {
      //   Message({
      //     message: '导入模板不能为空',
      //     type: 'error'
      //   })
      // }
    },
    async importData(herder, excelData = [], page = 0, limit = 1000, size = 0) {
      try {
        if (page * limit >= size) {
          return true
        }
        let data = {
          progressNum: page * limit,
          user_id: this.$store.getters.getUser.user_id,
          tenant_id: this.$store.getters.getUser.tenant_id,
          data: [herder, ...excelData.slice(page * limit, (page + 1) * limit)],
        }

        let response = await http.post('/wapi/excel/imortProductSku', data)
        if (!response) {
          return false
        }
        if (response.statusCode === 502) {
          return await this.importData(herder, excelData, page, limit, size)
        }
        this.loadingText =
          '正在导入数据' +
          (((page + 1) * limit) / size > 1 ? '100%' : ((((page + 1) * limit) / size) * 100).toFixed(0) + '% ')
        let progressText = (page + 1) * limit >= size ? ` (${size} / ${size})` : ` (${(page + 1) * limit} / ${size})`
        this.loadingText += progressText

        if (response.success) {
          this.record.push(true)
          if (response.data) {
            if (!this.errData) {
              this.errData = []
            }
            this.errData = [...this.errData, ...response.data]
          }
        } else {
          this.record.push(false)
        }
        return await this.importData(herder, excelData, page + 1, limit, size)
      } catch (e) {
        return false
      }
    },
    async imortDataClick1() {
      if (this.excelData1.length === 0) {
        this.$message.error('请选择导入模板！')
        return false
      }
      this.loading = true
      this.loadingText = `正在导入数据0%(0/${this.excelData1.length - 1})`
      this.errData1 = ''
      this.record = []
      let herder = this.excelData1[0]
      let res = await this.importData1(herder, this.excelData1.slice(1), 0, 500, this.excelData1.length - 1)

      if (!res) {
        this.$message.error('导入失败')
        this.loading = false
        this.loadingText = '拼命加载中'
      } else {
        if (this.record.some((item) => item)) {
          this.$message.success('导入成功')
          await this.getLibrary('FirstRefresh')
          this.loadingText = '拼命加载中'
          this.loading = false
          if (this.errData1.length > 0) {
            this.showModal_a = true
            this.errorData1 = this.errData1.slice(0, 100)
          }
        } else {
          this.$message.error('导入失败')
          this.loading = false
          this.loadingText = '拼命加载中'
        }
      }
    },
    async importData1(herder, excelData = [], page = 0, limit = 1000, size = 0) {
      try {
        if (page * limit >= size) {
          return true
        }
        let data = {
          progressNum: page * limit,
          user_id: this.$store.getters.getUser.user_id,
          tenant_id: this.$store.getters.getUser.tenant_id,
          data: [herder, ...excelData.slice(page * limit, (page + 1) * limit)],
        }

        let response = await http.post('/wapi/excel/imortProduct', data)
        if (!response) {
          return false
        }
        if (response.statusCode === 502) {
          return await this.importData1(herder, excelData, page, limit, size)
        }
        this.loadingText =
          '正在导入数据' +
          (((page + 1) * limit) / size > 1 ? '100%' : ((((page + 1) * limit) / size) * 100).toFixed(0) + '% ')
        let progressText = (page + 1) * limit >= size ? ` (${size} / ${size})` : ` (${(page + 1) * limit} / ${size})`
        this.loadingText += progressText

        if (response.success) {
          this.record.push(true)
          if (response.data) {
            if (!this.errData1) {
              this.errData1 = []
            }
            this.errData1 = [...this.errData1, ...response.data]
          }
        } else {
          this.record.push(false)
        }
        return await this.importData1(herder, excelData, page + 1, limit, size)
      } catch (e) {
        return false
      }
    },

    async imortDataClick2() {
      if (this.excelData2.length === 0) {
        this.$message.error('请选择导入模板！')
        return false
      }
      this.loading = true
      this.loadingText = `正在导入数据0%(0/${this.excelData2.length - 1})`
      this.errData2 = ''
      this.record = []
      let herder = this.excelData2[0]
      let res = await this.importData2(herder, this.excelData2.slice(1), 0, 500, this.excelData2.length - 1)

      if (!res) {
        this.$message.error('导入失败')
        this.loading = false
        this.loadingText = '拼命加载中'
      } else {
        if (this.record.some((item) => item)) {
          this.$message.success('导入成功')
          this.loadingText = '拼命加载中'
          this.loading = false
          if (this.errData2.length > 0) {
            this.showModal_b = true
            this.errorData2 = this.errData2.slice(0, 100)
          }
        } else {
          this.$message.error('导入失败')
          this.loading = false
          this.loadingText = '拼命加载中'
        }
      }
    },
    async importData2(herder, excelData = [], page = 0, limit = 1000, size = 0) {
      try {
        if (page * limit >= size) {
          return true
        }
        let data = {
          progressNum: page * limit,
          user_id: this.$store.getters.getUser.user_id,
          tenant_id: this.$store.getters.getUser.tenant_id,
          data: [herder, ...excelData.slice(page * limit, (page + 1) * limit)],
        }

        let response = await http.post('/wapi/excel/imortProductTrial', data)
        if (!response) {
          return false
        }
        if (response.statusCode === 502) {
          return await this.importData2(herder, excelData, page, limit, size)
        }
        this.loadingText =
          '正在导入数据' +
          (((page + 1) * limit) / size > 1 ? '100%' : ((((page + 1) * limit) / size) * 100).toFixed(0) + '% ')
        let progressText = (page + 1) * limit >= size ? ` (${size} / ${size})` : ` (${(page + 1) * limit} / ${size})`
        this.loadingText += progressText

        if (response.success) {
          this.record.push(true)
          if (response.data) {
            if (!this.errData2) {
              this.errData2 = []
            }
            this.errData2 = [...this.errData2, ...response.data]
          }
        } else {
          this.record.push(false)
        }
        return await this.importData2(herder, excelData, page + 1, limit, size)
      } catch (e) {
        return false
      }
    },
    async imortDataClick3() {
      if (this.excelData3.length === 0) {
        this.$message.error('请选择导入模板！')
        return false
      }
      this.loading = true
      this.loadingText = `正在导入数据0%(0/${this.excelData3.length - 1})`
      this.errData3 = ''
      this.record = []
      let herder = this.excelData3[0]
      let res = await this.importData3(herder, this.excelData3.slice(1), 0, 500, this.excelData3.length - 1)

      if (!res) {
        this.$message.error('导入失败')
        this.loading = false
        this.loadingText = '拼命加载中'
      } else {
        if (this.record.some((item) => item)) {
          this.$message.success('导入成功')
          this.loadingText = '拼命加载中'
          this.loading = false
          if (this.errData3.length > 0) {
            this.showModal_c = true
            this.errorData3 = this.errData3.slice(0, 100)
          }
        } else {
          this.$message.error('导入失败')
          this.loading = false
          this.loadingText = '拼命加载中'
        }
      }
    },
    async importData3(herder, excelData = [], page = 0, limit = 1000, size = 0) {
      try {
        if (page * limit >= size) {
          return true
        }
        let data = {
          progressNum: page * limit,
          user_id: this.$store.getters.getUser.user_id,
          tenant_id: this.$store.getters.getUser.tenant_id,
          data: [herder, ...excelData.slice(page * limit, (page + 1) * limit)],
        }

        let response = await http.post('/wapi/excel/imortProductCompetitor', data)
        if (!response) {
          return false
        }
        if (response.statusCode === 502) {
          return await this.importData3(herder, excelData, page, limit, size)
        }
        this.loadingText =
          '正在导入数据' +
          (((page + 1) * limit) / size > 1 ? '100%' : ((((page + 1) * limit) / size) * 100).toFixed(0) + '% ')
        let progressText = (page + 1) * limit >= size ? ` (${size} / ${size})` : ` (${(page + 1) * limit} / ${size})`
        this.loadingText += progressText

        if (response.success) {
          this.record.push(true)
          if (response.data) {
            if (!this.errData3) {
              this.errData3 = []
            }
            this.errData3 = [...this.errData3, ...response.data]
          }
        } else {
          this.record.push(false)
        }
        return await this.importData3(herder, excelData, page + 1, limit, size)
      } catch (e) {
        return false
      }
    },

    async imortDataClick4() {
      if (this.excelData4.length === 0) {
        this.$message.error('请选择导入模板！')
        return false
      }
      this.loading = true
      this.loadingText = `正在导入数据0%(0/${this.excelData4.length - 1})`
      this.errData4 = ''
      this.record = []
      let herder = this.excelData4[0]
      let res = await this.importData4(herder, this.excelData4.slice(1), 0, 5000, this.excelData4.length - 1)

      if (!res) {
        this.$message.error('导入失败')
        this.loading = false
        this.loadingText = '拼命加载中'
      } else {
        if (this.record.some((item) => item)) {
          this.$message.success('导入成功')
          this.loadingText = '拼命加载中'
          this.loading = false
          if (this.errData4.length > 0) {
            this.showModal_d = true
            this.errorData4 = this.errData4.slice(0, 100)
          }
        } else {
          this.$message.error('导入失败')
          this.loading = false
          this.loadingText = '拼命加载中'
        }
      }
    },
    async importData4(herder, excelData = [], page = 0, limit = 1000, size = 0,isdelete=true) {
      try {
        if (page * limit >= size) {
          return true
        }
        let data = {
          progressNum: page * limit,
          user_id: this.$store.getters.getUser.user_id,
          tenant_id: this.$store.getters.getUser.tenant_id,
          data: [herder, ...excelData.slice(page * limit, (page + 1) * limit)],
          isdelete:isdelete
        }

        let response = await http.post('/wapi/excel/imortProductSkuBatch', data)
        if (!response) {
          return false
        }
        if (response.statusCode === 502) {
          return await this.importData4(herder, excelData, page, limit, size)
        }
        this.loadingText =
          '正在导入数据' +
          (((page + 1) * limit) / size > 1 ? '100%' : ((((page + 1) * limit) / size) * 100).toFixed(0) + '% ')
        let progressText = (page + 1) * limit >= size ? ` (${size} / ${size})` : ` (${(page + 1) * limit} / ${size})`
        this.loadingText += progressText

        if (response.success) {
          this.record.push(true)
          if (response.data) {
            if (!this.errData4) {
              this.errData4 = []
            }
            this.errData4 = [...this.errData4, ...response.data]
          }
        } else {
          this.record.push(false)
        }
        return await this.importData4(herder, excelData, page + 1, limit, size,false)
      } catch (e) {
        return false
      }
    },
    // imortDataClick () {
    //     if (this.isUpload) {
    //         this.$refs.upload.submit()
    //     } else {
    //         Message({
    //             showClose: true,
    //             message: '导入模板不能为空',
    //             type: 'error'
    //         })
    //     }
    // },
    // handleChange (file, fileList) {
    //
    //     this.file = file.name
    //     const nameArr = file.name.split('.')
    //     const extension = nameArr[nameArr.length-1] === 'xlsx'
    //     const isLt2M = file.size / 1024 / 1024 < 10
    //     if (!extension) {
    //         this.file = ''
    //         this.fileList = []
    //         Message({
    //             showClose: true,
    //             message: '上传模板只能是xlsx',
    //             type: 'error'
    //         })
    //     }
    //     if (!isLt2M) {
    //         this.file = ''
    //         this.fileList = []
    //         Message({
    //             showClose: true,
    //             message: '传模板大小不能超过 10MB',
    //             type: 'error'
    //         })
    //     }
    //     this.isUpload = true
    //
    //     return extension && isLt2M
    // },
    async getParsingFile(fileName) {
      return new Promise(function (resolve, reject) {
        //定义reader，存放文件读取方法
        let reader = new FileReader()

        //启动函数
        reader.readAsBinaryString(fileName)
        //onload文件读取成功
        reader.onload = function (e) {
          //workbook存放excel的所有基本信息
          let workbook = xlsx.read(e.target.result, { type: 'binary' })
          xlsx.onprogress = function (e) { }
          //定义sheetList中存放excel表格的sheet表，就是最下方的tab
          let sheetList = workbook.SheetNames

          //存放json数组格式的表格数据
          let resultJson = []
          if (sheetList.length > 1) {
            reject({ status: false, message: '模板错误,不能有1个以上sheet' })
          }
          sheetList.forEach(function (y) {
            let worksheet = workbook.Sheets[y]
            resultJson = xlsx.utils.sheet_to_json(workbook.Sheets[y], { defval: '' })
          })

          if (resultJson.length === 0) {
            resolve({ status: true, data: resultJson })
          }
          //取出表头
          let tableHeader = Object.keys(resultJson[0])

          //取出表数据
          let importInfo = resultJson.map((item) => {
            return tableHeader.map((v) => item[v])
          })

          importInfo = [tableHeader, ...importInfo]
          resolve({ status: true, data: importInfo })
        }
        //文件读取失败
        reader.onerror = function (e) {
          reject({ status: false, message: '解析失败' })
        }
      })
    },

    async handleChange(file, fileList) {
      this.loading = true
      this.$refs.upload.clearFiles()
      this.loadingText = '文件解析中'
      let res = await this.getParsingFile(file.raw)

      setTimeout(() => {
        this.loading = false
        this.loadingText = '拼命加载中'
      }, 1000)
      if (!res.status) {
        this.$message.error(res.message)
        this.fileList = []
        return
      }

      if (res.data.length === 0 || res.data[0].length !== 10 || res.data[0][0].trim() !== '品类编码') {
        this.$message.error('模板错误，请选择正确的模板')
        this.fileList = []
        return false
      }
      if (res.data.slice(1).length === 0) {
        this.$message.error('导入数据必须大于0条')
        this.fileList = []
        return false
      }
      if (fileList.length !== 0 && res) {
        this.file = file.name
      }
      this.excelData = res.data
      // this.file = file.name
      // const nameArr = file.name.split('.')
      // const extension = nameArr[nameArr.length-1] === 'xlsx'
      // const isLt2M = file.size / 1024 / 1024 < 10
      // if (!extension) {
      //   this.file = ''
      //   this.fileList = []
      //   Message({
      //     showClose: true,
      //     message: '上传模板只能是xlsx',
      //     type: 'error'
      //   })
      // }
      // if (!isLt2M) {
      //   this.file = ''
      //   this.fileList = []
      //   Message({
      //     showClose: true,
      //     message: '传模板大小不能超过 10MB',
      //     type: 'error'
      //   })
      // }
      // this.isUpload = true
      // return extension && isLt2M
    },
    async handleChange1(file, fileList) {
      this.loading = true
      this.$refs.upload1.clearFiles()
      this.loadingText = '文件解析中'
      let res = await this.getParsingFile(file.raw)

      setTimeout(() => {
        this.loading = false
        this.loadingText = '拼命加载中'
      }, 1000)
      if (!res.status) {
        this.$message.error(res.message)
        this.fileList1 = []
        return
      }

      if (res.data.length === 0 || res.data[0].length !== 3 || res.data[0][0].trim() !== '品类编码') {
        this.$message.error('模板错误，请选择正确的模板')
        this.fileList1 = []
        return false
      }
      if (res.data.slice(1).length === 0) {
        this.$message.error('导入数据必须大于0条')
        this.fileList1 = []
        return false
      }
      if (fileList.length !== 0 && res) {
        this.file1 = file.name
      }
      this.excelData1 = res.data
    },
    async handleChange2(file, fileList) {
      this.loading = true
      this.$refs.upload2.clearFiles()
      this.loadingText = '文件解析中'
      let res = await this.getParsingFile(file.raw)

      setTimeout(() => {
        this.loading = false
        this.loadingText = '拼命加载中'
      }, 1000)
      if (!res.status) {
        this.$message.error(res.message)
        this.fileList2 = []
        return
      }

      if (res.data.length === 0 || res.data[0].length !== 10 || res.data[0][0].trim() !== '品类编码') {
        this.$message.error('模板错误，请选择正确的模板')
        this.fileList2 = []
        return false
      }
      if (res.data.slice(1).length === 0) {
        this.$message.error('导入数据必须大于0条')
        this.fileList2 = []
        return false
      }
      if (fileList.length !== 0 && res) {
        this.file2 = file.name
      }
      this.excelData2 = res.data
    },
    async handleChange3(file, fileList) {
      this.loading = true
      this.$refs.upload3.clearFiles()
      this.loadingText = '文件解析中'
      let res = await this.getParsingFile(file.raw)

      setTimeout(() => {
        this.loading = false
        this.loadingText = '拼命加载中'
      }, 1000)
      if (!res.status) {
        this.$message.error(res.message)
        this.fileList3 = []
        return
      }

      if (res.data.length === 0 || res.data[0].length !== 10 || res.data[0][0].trim() !== '品类编码') {
        this.$message.error('模板错误，请选择正确的模板')
        this.fileList3 = []
        return false
      }
      if (res.data.slice(1).length === 0) {
        this.$message.error('导入数据必须大于0条')
        this.fileList3 = []
        return false
      }
      if (fileList.length !== 0 && res) {
        this.file3 = file.name
      }
      this.excelData3 = res.data
    },
    async handleChange4(file, fileList) {
      this.loading = true
      this.$refs.upload4.clearFiles()
      this.loadingText = '文件解析中'
      let res = await this.getParsingFile(file.raw)

      setTimeout(() => {
        this.loading = false
        this.loadingText = '拼命加载中'
      }, 1000)
      if (!res.status) {
        this.$message.error(res.message)
        this.fileList4 = []
        return
      }

      if (res.data.length === 0 || res.data[0].length !== 3 || res.data[0][0].trim() !== 'SKU编码') {
        this.$message.error('模板错误，请选择正确的模板')
        this.fileList4 = []
        return false
      }
      if (res.data.slice(1).length === 0) {
        this.$message.error('导入数据必须大于0条')
        this.fileList4 = []
        return false
      }
      if (fileList.length !== 0 && res) {
        this.file4 = file.name
      }
      this.excelData4 = res.data
    },
    async handleSuccess(res, file) {
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      if (res.success) {
        try {
          //                        var user = this.$store.getters.getUser

          let data = {
            user_id: this.$store.getters.getUser.user_id,
            tenant_id: this.$store.getters.getUser.tenant_id,
            path: res.data,
          }

          await http.post('/wapi/excel/imortProductSku', data).then((res) => {
            loading.close()
            if (res.success) {
              this.closeModal2()

              if (res.data.length == 0) {
                Message({
                  type: 'success',
                  message: '导入成功',
                })
              } else {
                this.showModal2 = true
                this.Mechanism = [...res.data]
                this.arr = [...res.data]
              }
            } else {
              this.fileList = []

              Message({
                type: 'error',
                message: '导入失败',
              })
            }

            this.loading = false
          })
        } catch (err) {
          loading.close()
          Message.error('导入失败！')
        }
      } else {
        loading.close()
        Message.error('导入失败！')
      }
    },
    closeModal2() {
      this.fileList = []
      this.fileList1 = []
      this.fileList2 = []
      this.fileList3 = []
      this.fileList4 = []
      this.excelData = []
      this.excelData1 = []
      this.excelData2 = []
      this.excelData3 = []
      this.excelData4 = []
      this.dialogVisible5 = false
      this.isUpload = false
    },
    daoru() {
      this.file = ''
      this.file1 = ''
      this.file2 = ''
      this.file3 = ''
      this.dialogVisible5 = true
    },
    async getDosage() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
      }
      await http.post('/wapi/product/getDosage', data).then((res) => {
        if (res.success === true) {
          this.getDosageList = res.data
        }
      })
    },
    //删除列表
    deleteOpen2(index, row) {
      MessageBox.confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.deleteProductSku(index, row)
        })
        .catch(() => {
          Message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    async deleteProductSku(index, row) {
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser
        let data = {}
        let sku_id = row.sku_id
        data = { sku_id: sku_id, tenant_id: user.tenant_id, user_id: user.user_id }

        await http.post('/wapi/product_sku/deleteProductSku', data).then((res) => {
          loading.close()
          if (res.success) {
            this.getDictionaryList(this.MyData)
            Message({
              type: 'success',
              message: '删除成功!',
            })
          } else {
            Message.error('删除失败')
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },

    submitForm4() {
      if (this.activeName1 == 'first') {
        this.$refs['ruleForm4'].validate((valid) => {
          if (!valid) {
            return false
          } else {
            this.updataProductSku()
          }
        })
      } else {
        let off = true
        for (var i = 0; i < this.extendedInfo1.length; i++) {
          if (this.extendedInfo1[i].mandatory == 'T') {
            this.$refs['skuList' + i][0].validate((valid) => {
              if (!valid) {
                off = false
              }
            })
          }
        }
        if (off) {
          this.updateExtendedInfo1()
        }
      }
    },
    //编辑SKU
    async updataProductSku() {
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser
        let data = {}
        let obj = this.updataListForm
        data = { ...obj, tenant_id: user.tenant_id, user_id: user.user_id }

        if (data.status === true) {
          data.status = 'ACTIVE'
        } else {
          data.status = 'INACTIVE'
        }

        await http.post('/wapi/product_sku/updataProductSku', data).then((res) => {
          loading.close()
          if (res.success) {
            if (res.data === '产品code不能重复') {
              Message({
                type: 'error',
                message: 'SKU编码不能重复',
              })
            } else {
              this.getDictionaryList(this.MyData)
              this.dialogFormVisible4 = false
              Message({
                type: 'success',
                message: '保存成功',
              })
            }
          } else {
            Message.error('保存失败')
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },

    submitForm4Trial() {
      if (this.activeName1Trial === 'first') {
        this.$refs['ruleForm4Trial'].validate((valid) => {
          if (!valid) {
            return false
          } else {
            this.updataProductTrial()
          }
        })
      } else {
        let off = true
        for (var i = 0; i < this.extendedInfo1Trial.length; i++) {
          if (this.extendedInfo1Trial[i].mandatory === 'T') {
            this.$refs['trialList' + i][0].validate((valid) => {
              if (!valid) {
                off = false
              }
            })
          }
        }

        if (off) {
          this.updateExtendedInfo1Trial()
        }
      }
    },
    //编辑SKU
    async updataProductTrial() {
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser
        let data = {}
        let obj = this.updataListFormTrial
        data = { ...obj, tenant_id: user.tenant_id, user_id: user.user_id }

        if (data.status === true) {
          data.status = 'ACTIVE'
        } else {
          data.status = 'INACTIVE'
        }

        await http.post('/wapi/product_sku/updataProductTrial', data).then((res) => {
          loading.close()
          if (res.success) {
            if (res.data === '产品code不能重复') {
              Message({
                type: 'error',
                message: '样品编码不能重复',
              })
            } else {
              this.getTrialList(this.MyData)
              this.dialogFormVisible4Trial = false
              Message({
                type: 'success',
                message: '保存成功',
              })
            }
          } else {
            Message.error('保存失败')
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },

    submitForm4Competitor() {
      if (this.activeName1Competitor === 'first') {
        this.$refs['ruleForm4Competitor'].validate((valid) => {
          if (!valid) {
            return false
          } else {
            this.updataProductCompetitor()
          }
        })
      } else {
        let off = true
        for (var i = 0; i < this.extendedInfo1Competitor.length; i++) {
          if (this.extendedInfo1Competitor[i].mandatory === 'T') {
            this.$refs['competitorList' + i][0].validate((valid) => {
              if (!valid) {
                off = false
              }
            })
          }
        }
        if (off) {
          this.updateExtendedInfo1Competitor()
        }
      }
    },
    //编辑SKU
    async updataProductCompetitor() {
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser
        let data = {}
        let obj = this.updataListFormCompetitor
        data = { ...obj, tenant_id: user.tenant_id, user_id: user.user_id }

        if (data.status === true) {
          data.status = 'ACTIVE'
        } else {
          data.status = 'INACTIVE'
        }

        await http.post('/wapi/product_sku/updataProductCompetitor', data).then((res) => {
          loading.close()
          if (res.success) {
            if (res.data === '产品code不能重复') {
              Message({
                type: 'error',
                message: '样品编码不能重复',
              })
            } else {
              this.getCompetitorList(this.MyData)
              this.dialogFormVisible4Competitor = false
              Message({
                type: 'success',
                message: '保存成功',
              })
            }
          } else {
            Message.error('保存失败')
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },

    submitForm3() {
      this.$refs['ruleForm3'].validate((valid) => {
        if (valid) {
          this.addProductSku()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    //新增SKU
    async addProductSku() {
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser

        let data = {}
        let obj = this.addListForm
        let product_id = this.MyData.product_id
        data = { ...obj, product_id: product_id, tenant_id: user.tenant_id, user_id: user.user_id }

        if (data.status === true) {
          data.status = 'ACTIVE'
        } else {
          data.status = 'INACTIVE'
        }
        // console.log(data)
        await http.post('/wapi/product_sku/addProductSku', data).then((res) => {
          loading.close()
          if (res.success) {
            if (res.data === '产品code不能重复') {
              Message({
                type: 'error',
                message: 'SKU编码不能重复',
              })
            } else {
              for (let key in this.addListForm) {
                this.addListForm[key] = ''
              }
              this.addListForm.status = true
              this.dialogFormVisible3 = false
              this.getDictionaryList(this.MyData)
              Message({
                type: 'success',
                message: '保存成功',
              })
            }
          } else {
            Message.error('保存失败')
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },

    submitForm3Trial() {
      this.$refs['ruleForm3Trial'].validate((valid) => {
        if (valid) {
          this.addProductTrial()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    //新增SKU
    async addProductTrial() {
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser

        let data = {}
        let obj = this.addListFormTrial
        let product_id = this.MyData.product_id
        data = { ...obj, product_id: product_id, tenant_id: user.tenant_id, user_id: user.user_id }

        if (data.status === true) {
          data.status = 'ACTIVE'
        } else {
          data.status = 'INACTIVE'
        }
        // console.log(data)
        await http.post('/wapi/product_sku/addProductTrial', data).then((res) => {
          loading.close()
          if (res.success) {
            if (res.data === '产品code不能重复') {
              Message({
                type: 'error',
                message: '样品编码不能重复',
              })
            } else {
              for (let key in this.addListFormTrial) {
                this.addListFormTrial[key] = ''
              }
              this.addListFormTrial.status = true
              this.dialogFormVisible3Trial = false
              this.getTrialList(this.MyData)
              Message({
                type: 'success',
                message: '保存成功',
              })
            }
          } else {
            Message.error('保存失败')
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },

    submitForm3Competitor() {
      this.$refs['ruleForm3Competitor'].validate((valid) => {
        if (valid) {
          this.addProductCompetitor()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    //新增SKU
    async addProductCompetitor() {
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser

        let data = {}
        let obj = this.addListFormCompetitor
        let product_id = this.MyData.product_id
        data = { ...obj, product_id: product_id, tenant_id: user.tenant_id, user_id: user.user_id }

        if (data.status === true) {
          data.status = 'ACTIVE'
        } else {
          data.status = 'INACTIVE'
        }
        // console.log(data)
        await http.post('/wapi/product_sku/addProductCompetitor', data).then((res) => {
          loading.close()
          if (res.success) {
            if (res.data === '产品code不能重复') {
              Message({
                type: 'error',
                message: '' + '竞品编码不能重复',
              })
            } else {
              for (let key in this.addListFormCompetitor) {
                this.addListFormCompetitor[key] = ''
              }
              this.addListFormCompetitor.status = true
              this.dialogFormVisible3Competitor = false
              this.getCompetitorList(this.MyData)
              Message({
                type: 'success',
                message: '保存成功',
              })
            }
          } else {
            Message.error('保存失败')
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },

    //获取产品
    async getDictionaryList(treeData) {
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser
        let data = {
          product_id: treeData.product_id,
          // category: 'INSPECTION_ITEM',
          tenant_id: user.tenant_id,
        }
        number = 1
        this.tableData = []

        await http.post('/wapi/product_sku/getProductSkuListByProductid', data).then((res) => {
          debugger
          loading.close()
          if (res.success) {
            /*this.$set(this.tableData,'values',[])
                            for (let key in res.data) {
                                if(key.indexOf('value')===-1){
                                    this.$set(this.tableData,key,res.data[key])
                                }else {
                                    this.tableData.values.push(res.data[key])
                                }
                            }*/
            this.tableData = res.data

            this.tableData.forEach((item) => {
              if (item.status === 'ACTIVE') {
                item.status = true
                item.textStatus = '有效'
              } else if (item.status !== 'ACTIVE') {
                item.status = false
                item.textStatus = '无效'
              }
            })
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },
    //获取样品
    async getTrialList(treeData) {
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser
        let data = {
          product_id: treeData.product_id,
          // category: 'INSPECTION_ITEM',
          tenant_id: user.tenant_id,
        }
        number = 1
        this.tableTrial = []

        await http.post('/wapi/product_sku/getProductTriaListByProductid', data).then((res) => {
          loading.close()
          if (res.success) {
            this.tableTrial = res.data

            this.tableTrial.forEach((item) => {
              if (item.status === 'ACTIVE') {
                item.status = true
                item.textStatus = '有效'
              } else if (item.status !== 'ACTIVE') {
                item.status = false
                item.textStatus = '无效'
              }
            })
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },
    //获取样品
    async getCompetitorList(treeData) {
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser
        let data = {
          product_id: treeData.product_id,
          // category: 'INSPECTION_ITEM',
          tenant_id: user.tenant_id,
        }
        number = 1
        this.tableCompetitor = []

        await http.post('/wapi/product_sku/getProductCompetitorListByProductid', data).then((res) => {
          loading.close()
          if (res.success) {
            this.tableCompetitor = res.data

            this.tableCompetitor.forEach((item) => {
              if (item.status === 'ACTIVE') {
                item.status = true
                item.textStatus = '有效'
              } else if (item.status !== 'ACTIVE') {
                item.status = false
                item.textStatus = '无效'
              }
            })
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },
    //获取目录
    async getLibrary(type) {
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser
        let data = {
          tenant_id: user.tenant_id,
          user_id: user.user_id,
        }
        await http.post('/wapi/product/getProductList', data).then((res) => {
          // console.log(res)
          loading.close()
          // this.$nextTick(() => { this.$refs.tree.setCurrentKey(this.treeKey)})
          setTimeout(() => {
            this.$refs.tree.setCurrentKey(this.treeKey)
          }, 100)
          if (res.success) {
            this.data = [
              { define_id: 1000, label: '已启用', children: [] },
              { define_id: 2000, label: '已停用', children: [] },
            ]
            for (let i = 0; i < res.data.length; i++) {
              res.data[i].define_id = res.data[i].product_id
              if (res.data[i].status === 'ACTIVE') {
                this.data[0].children.push(res.data[i])
              } else {
                this.data[1].children.push(res.data[i])
              }
            }
            if (this.data[1].children.length == 0) {
              this.data.splice(1, 1)
            }
          }
        })

        if (type === 'FirstRefresh')
          this.$nextTick().then(() => {
            const firstNode = document.querySelector('.el-tree-node')
            const firstNode_children = firstNode.querySelector('.el-tree-node__children')
            const firstNode_children_children = firstNode_children.querySelector('.el-tree-node')
            setTimeout(() => {
              firstNode_children_children.click()
            }, 100)
          })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },
    //删除产品
    deleteOpen(node, data2) {
      MessageBox.confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.removeProduct(node, data2)
        })
        .catch(() => {
          Message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    //删除产品
    async removeProduct(node, data2) {
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser
        let data = {}
        data.tenant_id = user.tenant_id
        data.user_id = user.user_id
        data.product_id = data2.product_id

        await http.post('/wapi/product/deleteProduct', data).then((res) => {
          loading.close()
          if (res.success) {
            const parent = node.parent
            const children = parent.data.children || parent.data
            const index = children.findIndex((d) => d.id === data.id)
            children.splice(index, 1)
            Message({
              type: 'success',
              message: '删除成功',
            })
          } else {
            Message.error('删除失败')
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },

    submitForm() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.addDictionaryDefine()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    //新增产品
    async addDictionaryDefine() {
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser
        let data = JSON.parse(JSON.stringify(this.form))
        data.tenant_id = user.tenant_id
        data.user_id = user.user_id
        data.status = this.productStatusCreate ? 'ACTIVE' : 'INACTIVE'

        await http.post('/wapi/product/addProduct', data).then((res) => {
          loading.close()
          if (res.success) {
            if (res.data === 'product_code不能重复') {
              Message({
                type: 'error',
                message: '品类编码不能重复',
              })
            } else {
              this.data.unshift({ ...res.data[0], ...{ label: res.data[0].product_name } })
              this.dialogFormVisible = false
              for (let key in this.form) {
                this.form[key] = ''
              }
              Message({
                type: 'success',
                message: '保存成功',
              })
              this.getLibrary('click').then((res) => {
                this.$refs.tree.setCurrentKey(this.define_id)
              })
            }
          } else {
            Message.error('保存失败')
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },

    submitForm2() {
      if (this.activeName === 'first') {
        this.$refs['ruleForm2'].validate((valid) => {
          if (!valid) {
            return false
          } else {
            this.updataProduct()
          }
        })
      } else {
        let off = true
        for (var i = 0; i < this.extendedInfo.length; i++) {
          if (this.extendedInfo[i].mandatory == 'T') {
            this.$refs['list' + i][0].validate((valid) => {
              if (!valid) {
                off = false
              }
            })
          }
        }
        if (off) {
          this.updateExtendedInfo()
        }
      }
    },
    //编辑产品
    async updataProduct() {
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser
        let data = JSON.parse(JSON.stringify(this.upForm))
        data.tenant_id = user.tenant_id
        data.user_id = user.user_id
        data.product_id = this.MyData.product_id
        data.status = this.productStatus ? 'ACTIVE' : 'INACTIVE'

        await http.post('/wapi/product/updataProduct', data).then((res) => {
          debugger
          loading.close()
          if (res.success) {
            if (res.data === 'INACTIVEALL') {
              Message.error('请先将所属品类的所有SKU、样品、竞品停用')
            } else if (res.data === 'product_code不能重复') {
              Message({
                type: 'error',
                message: '品类编码不能重复',
              })
            } else if (res.data.code === 1001) {
              Message({
                type: 'error',
                message: res.data.data,
              })
            } else {
              this.schTitle1 = res.data[0].product_name
              this.schTitle1Code = res.data[0].product_code
              res.data[0].label = res.data[0].product_name
              // let a=this.per
              // console.log(this.data[a])
              // console.log( res.data[0])
              // this.data.splice(a,1,res.data[0])
              this.dialogFormVisible2 = false
              this.nodeData = res.data[0]
              this.getLibrary('click').then((res) => {
                this.$refs.tree.setCurrentKey(this.define_id)
              })
              Message({
                type: 'success',
                message: '保存成功',
              })
            }
          } else {
            Message.error('保存失败')
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },
    //新增字典保存按钮
    //树状列表
    filterNode(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },

    unopen() {
      this.$refs['ruleForm'].resetFields()
      this.dialogFormVisible = false
      for (let key in this.form) {
        this.form[key] = ''
      }
    },
    unopen2() {
      this.$refs['ruleForm2'].resetFields()
      this.dialogFormVisible2 = false
      this.extendedInfo = []
      for (let key in this.upForm) {
        this.upForm[key] = ''
      }
    },
    unopen3() {
      this.$refs['ruleForm3'].resetFields()
      this.dialogFormVisible3 = false
      for (let key in this.addListForm) {
        this.addListForm[key] = ''
      }
    },
    unopen3Trial() {
      this.$refs['ruleForm3Trial'].resetFields()
      this.dialogFormVisible3Trial = false
      for (let key in this.addListFormTrial) {
        this.addListFormTrial[key] = ''
      }
    },
    unopen3Competitor() {
      this.$refs['ruleForm3Competitor'].resetFields()
      this.dialogFormVisible3Competitor = false
      for (let key in this.addListFormCompetitor) {
        this.addListFormCompetitor[key] = ''
      }
    },
    unopen4() {
      this.$refs['ruleForm4'].resetFields()
      this.dialogFormVisible4 = false
      for (let key in this.updataListForm) {
        this.updataListForm[key] = ''
      }
      this.extendedInfo1 = []
    },
    unopen4Trial() {
      this.$refs['ruleForm4Trial'].resetFields()
      this.dialogFormVisible4Trial = false
      for (let key in this.updataListFormTrial) {
        this.updataListFormTrial[key] = ''
      }
      this.extendedInfo1Trial = []
    },
    unopen4Competitor() {
      this.$refs['ruleForm4Competitor'].resetFields()
      this.dialogFormVisible4Competitor = false
      for (let key in this.updataListFormCompetitor) {
        this.updataListFormCompetitor[key] = ''
      }
      this.extendedInfo1Competitor = []
    },
    //新建顶级文件夹
    append2(value) {
      const newChild = { id: id++, label: value, children: [] }
      this.data2.push(newChild)
    },
    //新建产品弹框
    open3() {
      this.dialogFormVisible = true
      this.stateNum = 1
    },
    //编辑产品弹框
    open4(node, data) {
      this.upForm.product_name = data.product_name
      this.upForm.product_code = data.product_code
      this.upForm.comments = data.comments
      this.upForm.category = data.category
      this.upForm.brand = data.brand
      this.treeId = node.id
      this.dialogFormVisible2 = true
      this.productStatus = data.status === 'ACTIVE' ? true : false

      let parent = node.parent
      let id = node.id
      for (let i = 0; i < parent.length; i++) {
        if (parent[i].id === id) {
          this.per = i
        }
      }
      this.activeName = 'first'
      // this.getExtendedInfo()
    },
    //添加列表弹框
    addListOpen() {
      this.optionsNum = 1
      this.dialogFormVisible3 = true
    },
    //添加样品弹框
    addTrialListOpen() {
      // this.optionsNum=1
      this.dialogFormVisible3Trial = true
    },
    //添加竞品弹框
    addCompetitorListOpen() {
      // this.optionsNum=1
      this.dialogFormVisible3Competitor = true
    },

    //编辑按钮
    myDetails(index, row) {
      this.updataListForm = JSON.parse(JSON.stringify(row))
      // console.log(this.updataListForm)
      this.sku_id = this.updataListForm.sku_id
      this.activeName1 = 'first'
      // this.getExtendedInfo1()
      this.search_batch_no = "";
      this.getSkuBatchNo()
      this.dialogFormVisible4 = true
    },
    //编辑按钮
    myDetailsTrial(index, row) {
      this.updataListFormTrial = JSON.parse(JSON.stringify(row))
      this.sku_idTrial = this.updataListFormTrial.sku_id
      this.activeName1Trial = 'first'
      this.getExtendedInfo1Trial()
      this.dialogFormVisible4Trial = true
    },
    //编辑按钮
    myDetailsCompetitor(index, row) {
      this.updataListFormCompetitor = JSON.parse(JSON.stringify(row))
      this.sku_idCompetitor = this.updataListFormCompetitor.sku_id
      this.activeName1Competitor = 'first'
      this.getExtendedInfo1Competitor()
      this.dialogFormVisible4Competitor = true
    },
    //添加说明
    addExplain(form) {
      this.stateNum++
      if (this.stateNum <= 8) {
        this.$set(form, 'value' + this.stateNum, '')
      }
    }, //添加选项字段
    addOptions(form) {
      this.optionsNum++
      if (this.optionsNum <= 8) {
        this.$set(form, 'value' + this.optionsNum, '')
      }
    },
    //判断文本框类型
    judgeType(key) {
      if (key === 'name') {
        return 'input'
      } else if (key === 'category') {
        return 'input'
      } else {
        return 'textarea'
      }
    },

    onOff(key) {
      return parseInt(key.replace('value', '')) - 1
    },
    //判断键名
    judge(key) {
      if (key === 'name') {
        return '名称'
      } else if (key === 'category') {
        return '类型'
      } else if (key === 'value1') {
        return '说明1'
      } else if (key === 'value2') {
        return '说明2'
      } else if (key === 'value3') {
        return '说明3'
      } else if (key === 'value4') {
        return '说明4'
      } else if (key === 'value5') {
        return '说明5'
      } else if (key === 'value6') {
        return '说明6'
      } else if (key === 'value7') {
        return '说明7'
      } else if (key === 'value8') {
        return '说明8'
      } else {
        return key
      }
    },
    //点击行
    myRowClick(row) {
      if (row) {
        // this.form.user_id=row.user_id
        this.radio = parseInt(row.rowIndex)
        this.myStatus = row.status === 'ACTIVE' ? '在职' : '离职'

        if (row.zhuGuan === 'STAFF') {
          this.myZhuGuan = '否'
          this.form.zhuGuan = false
        } else if (row.zhuGuan === 'MANAGER') {
          this.myZhuGuan = '是'
          this.form.zhuGuan = true
        }
        this.tabActive = true
        this.tableDataRow = row
      }
    },

    handleNodeClick(data, node, ele) {
      if (data.label === '已启用' || data.label === '已停用') {
        this.addUserDis = true
        return
      } else {
        this.product_id = data.product_id
        this.nodeData = data
        this.dataNode = node

        this.treeKey = node.key
        this.define_id = data.define_id
        this.MyData = data

        this.getDictionaryList(data)
        this.getTrialList(data)
        this.getCompetitorList(data)
        this.myactive2 = false
        this.myactive1 = true
        this.schTitle1 = data.label
        this.schTitle1Code = data.product_code
        //禁用状态
        this.updataActive = true
        //编辑字典
        this.compileDic.define_id = data.define_id
        this.compileDic.old_category = data.category
        this.compileDic.tenant_id = data.tenant_id
        this.compileDic.category = data.category
        this.upForm.category = data.category
        this.upForm.name = data.name

        for (let key in this.upForm) {
          if (key.indexOf('value') !== -1) {
            this.$delete(this.upForm, key)
          }
        }
        this.len = 0
        this.valueArr = []
        for (let key in data) {
          if (key.indexOf('value') !== -1) {
            if (data[key]) {
              this.$set(this.upForm, key, data[key])
              this.valueArr.push(data[key])
              this.len++
            }
          }
        }
        //禁用状态
        if (data.onlyread === 'T') {
          this.updataActive = false
        } else {
          this.updataActive = true
        }
      }
    },

    async getExtendedInfo() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        product_id: this.product_id,
      }
      await http.post('/wapi/product/getExtendedInfo', data).then((res) => {
        if (res.success) {
          this.extendedInfo = res.data

          this.extendedInfo.forEach((item) => {
            if (
              item.input_type === 'LIST' &&
              item.multiple === 'T' &&
              item.field_value.indexOf('|') == -1 &&
              item.field_value !== ''
            ) {
              item.field_value = [item.field_value]
            }
            if (item.input_type === 'LIST' && item.field_value.indexOf('|') !== -1) {
              item.field_value = item.field_value.split('|')
            }
            if (item.input_type === 'LIST' && item.multiple === 'T' && item.field_value === '') {
              item.field_value = []
            }
            if (item.input_type === 'TRUE-FALSE' && item.field_value === '') {
              item.field_value = 'F'
            }
          })
        } else {
          Message.error(res.message)
        }
      })
    },
    async updateExtendedInfo() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        user_id: this.$store.getters.getUser.user_id,
        product_id: this.product_id,
        ExtensionArray: this.extendedInfo,
      }
      await http.post('/wapi/product/setExtendedList', data).then((res) => {
        if (res.success) {
          Message({
            type: 'success',
            message: '保存成功',
          })

          this.dialogFormVisible2 = false
          this.extendedInfo = []
        } else {
          Message.error(res.message)
        }
      })
    },
    async getExtendedInfo1() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        sku_id: this.sku_id,
      }
      await http.post('/wapi/product/getExtendedInfo1', data).then((res) => {
        if (res.success) {
          this.extendedInfo1 = res.data
          this.extendedInfo1.forEach((item) => {
            if (
              item.input_type === 'LIST' &&
              item.multiple === 'T' &&
              item.field_value.indexOf('|') == -1 &&
              item.field_value !== ''
            ) {
              item.field_value = [item.field_value]
            }
            if (item.input_type === 'LIST' && item.field_value.indexOf('|') !== -1) {
              item.field_value = item.field_value.split('|')
            }
            if (item.input_type === 'LIST' && item.multiple === 'T' && item.field_value === '') {
              item.field_value = []
            }
            if (item.input_type === 'TRUE-FALSE' && item.field_value === '') {
              item.field_value = 'F'
            }
          })
        } else {
          Message.error(res.message)
        }
      })
    },
    async getSkuBatchNo() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        sku_id: this.sku_id,
        batch_no: this.search_batch_no
      }
      await http.post('/crm/product/sku/getSkuBatchListBySkuId', data).then((res) => {
        console.log(res)
        if (res.success) {
          this.tableBatchNo = res.data;
        } else {
          Message.error(res.message)
        }
      })
    },
    async getExtendedInfo1Trial() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        sku_id: this.sku_idTrial,
      }
      await http.post('/wapi/product/getExtendedInfo1Trial', data).then((res) => {
        if (res.success) {
          this.extendedInfo1Trial = res.data
          this.extendedInfo1Trial.forEach((item) => {
            if (
              item.input_type === 'LIST' &&
              item.multiple === 'T' &&
              item.field_value.indexOf('|') == -1 &&
              item.field_value !== ''
            ) {
              item.field_value = [item.field_value]
            }
            if (item.input_type === 'LIST' && item.field_value.indexOf('|') !== -1) {
              item.field_value = item.field_value.split('|')
            }
            if (item.input_type === 'LIST' && item.multiple === 'T' && item.field_value === '') {
              item.field_value = []
            }
            if (item.input_type === 'TRUE-FALSE' && item.field_value === '') {
              item.field_value = 'F'
            }
          })
        } else {
          Message.error(res.message)
        }
      })
    },
    async getExtendedInfo1Competitor() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        sku_id: this.sku_idCompetitor,
      }
      await http.post('/wapi/product/getExtendedInfo1Competitor', data).then((res) => {
        if (res.success) {
          this.extendedInfo1Competitor = res.data
          this.extendedInfo1Competitor.forEach((item) => {
            if (
              item.input_type === 'LIST' &&
              item.multiple === 'T' &&
              item.field_value.indexOf('|') == -1 &&
              item.field_value !== ''
            ) {
              item.field_value = [item.field_value]
            }
            if (item.input_type === 'LIST' && item.field_value.indexOf('|') !== -1) {
              item.field_value = item.field_value.split('|')
            }
            if (item.input_type === 'LIST' && item.multiple === 'T' && item.field_value === '') {
              item.field_value = []
            }
            if (item.input_type === 'TRUE-FALSE' && item.field_value === '') {
              item.field_value = 'F'
            }
          })
        } else {
          Message.error(res.message)
        }
      })
    },
    async updateExtendedInfo1() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        user_id: this.$store.getters.getUser.user_id,
        product_id: this.product_id,
        sku_id: this.sku_id,
        ExtensionArray: this.extendedInfo1,
      }
      await http.post('/wapi/product/setExtendedList1', data).then((res) => {
        if (res.success) {
          Message({
            type: 'success',
            message: '保存成功',
          })

          this.dialogFormVisible4 = false
          this.extendedInfo1 = []
        } else {
          Message.error(res.message)
        }
      })
    },
    async updateExtendedInfo1Trial() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        user_id: this.$store.getters.getUser.user_id,
        product_id: this.product_id,
        sku_id: this.sku_idTrial,
        ExtensionArray: this.extendedInfo1Trial,
      }
      await http.post('/wapi/product/setExtendedList1Trial', data).then((res) => {
        if (res.success) {
          Message({
            type: 'success',
            message: '保存成功',
          })

          this.dialogFormVisible4Trial = false
          this.extendedInfo1Trial = []
        } else {
          Message.error(res.message)
        }
      })
    },
    async updateExtendedInfo1Competitor() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        user_id: this.$store.getters.getUser.user_id,
        product_id: this.product_id,
        sku_id: this.sku_idCompetitor,
        ExtensionArray: this.extendedInfo1Competitor,
      }
      await http.post('/wapi/product/setExtendedList1Competitor', data).then((res) => {
        if (res.success) {
          Message({
            type: 'success',
            message: '保存成功',
          })

          this.dialogFormVisible4Competitor = false
          this.extendedInfo1Competitor = []
        } else {
          Message.error(res.message)
        }
      })
    },
    clickTab(type) {
      if (type === 'SKU') {
        this.isProductType = 'SKU'
      } else if (type === '样品') {
        this.isProductType = 'TRIAL'
      } else if (type === '竞品') {
        this.isProductType = 'COMPETITOR'
      }
    },
  },
  updated() {
    //console.log(this.addListForm.status)
  },
}
</script>
<!--<style lang="scss" module>-->
<!--    .container {-->
<!--        background: white;-->
<!--        height: 100%;-->
<!--        overflow: auto;-->
<!--        .left {-->
<!--            font-size: 18px;-->
<!--            font-weight: bold;-->
<!--            color: #000000;-->
<!--            .search {-->
<!--                width: 360px;-->
<!--            }-->
<!--            .type {-->
<!--                em {-->
<!--                    color: #d98f2f;-->
<!--                    font-size: 14px;-->
<!--                    font-weight: bold;-->
<!--                }-->
<!--            }-->

<!--            .first {-->
<!--                color: #555555;-->
<!--                font-size: 20px;-->
<!--            }-->
<!--            .font {-->
<!--                margin-left: 20px;-->
<!--                font-size: 14px;-->
<!--                color: #555555;-->
<!--            }-->
<!--        }-->
<!--        .right {-->
<!--            margin-top: -20px;-->
<!--            width: 100%;-->
<!--            .header {-->
<!--                width: 100%;-->
<!--                padding-bottom: 6px;-->
<!--                border-bottom: 2px dotted #e7eaec;-->

<!--            }-->
<!--            .body {-->
<!--                overflow: auto;-->

<!--            }-->
<!--        }-->

<!--        -->
<!--    }-->
<!--</style>-->
<style>
/*#productSku{*/
/*    overflow: auto;*/
/*}*/
/*限制文字长度*/
#productSku .el-tree-node__content span {
  max-width: 250px;

  /*overflow: hidden;*/
  margin-left: 10px;
  color: #bbbbbb;
  /*text-overflow: ellipsis;*/
  font-size: 12px;
  white-space: normal;
}

#productSku .el-tree-node__expand-icon {
  display: none;
}

#productSku .el-tree-node__content {
  /*display: flex;*/
  /*justify-content: space-between;*/
  /*height: 40px;*/
  padding: 10px 0 10px 18px;
  height: auto;
}

#productSku .el-tree-node.is-expanded.is-focusable>.el-tree-node__content {
  /*background: #f6f7fa;*/
  background: none;
}

#productSku .filter-tree .el-tree-node__children>.el-tree-node>.el-tree-node__content:before {
  content: '';
  display: inline-block;
  background: url('../../assets/images/treeicon.png') no-repeat;
  background-size: 16px;
  width: 16px;
  height: 16px;
  margin: 0 20px;
}

#productSku .filter-tree .el-tree-node__children>.el-tree-node>.el-tree-node__content span {
  margin-left: 0;
  font-size: 16px;
  max-width: 250px;
  color: #606266;
  /*overflow: hidden;*/
  /*text-overflow: ellipsis;*/
  white-space: normal;
  line-height: 18px;
}

/*输入框背景*/
#productSku .sWei .el-input__inner {
  background: #eee;
}

#productSku .StoCen {
  background: white;
  height: auto;
  padding: 0 15px;
}

/*.el-main{
      padding: 0;
    }*/
#productSku {
  display: flex;
  /*justify-content: center;*/
  height: 100%;
}

#productSku .StoW .el-form-item__label {
  font-size: 14px;
  color: black;
  font-weight: bold;
}

#productSku .el-row {
  margin-bottom: 12px;
  /*height: 30px;*/
}

#productSku .xux {
  border-bottom: 2px dashed #eee;
  height: 10px;
}

#productSku .butC {
  padding: 8px 10px;
  margin-top: 26px;
}

element.style {
  display: block !important;
  /* text-align: left; */
}

#productSku .el-input__inner::-webkit-input-placeholder {
  text-align: left;
}

#productSku #seachRowSKU .sWei>.el-input__inner::-webkit-input-placeholder {
  text-align: center;
}

#productSku .tally {
  border: 2px solid rgb(29, 170, 252);
  height: 100%;
  width: 110px;
  margin: 0 10px;
  padding: 0 5px;
  color: rgb(29, 170, 252);
}

#productSku .tally:nth-of-type(2) {
  border-color: rgb(30, 255, 79);
  color: rgb(30, 255, 79);
}

#productSku .tally:nth-of-type(3) {
  border-color: rgb(255, 203, 30);
  color: rgb(255, 203, 30);
}

#productSku .tally:nth-of-type(4) {
  border-color: rgb(255, 30, 244);
  color: rgb(255, 30, 244);
}

#productSku .tallyBox {
  height: 60px;
  display: flex;
  margin-bottom: 10px;
  justify-content: flex-end;
}

#productSku .tally .el-row {
  margin: 0;
  font-size: 12px;
  height: 25px;
}

#productSku .tally .el-row:nth-of-type(2) {
  text-align: center;
  font-size: 20px;
}

#productSku .cell {
  text-align: left;
}

#productSku .el-dialog__header {
  border-bottom: 2px dashed #eee;
  padding: 20px 0 20px 0;
  margin: 20px 20px 10px;
}

#productSku .el-dialog__close {
  display: none;
}

/*#productSku .el-dialog__body{*/
/*padding-right:100px ;*/
/*}*/
#productSku .el-form-item__label {
  color: black;
  text-align: left;
}

#productSku .el-dialog__body {
  padding: 10px 20px;
}

#productDetails .el-form-item__label {
  font-size: 14px;
  color: black;
  font-weight: bold;
  text-align: left;
  padding-left: 20px;
}

#productDetails .el-dialog__header {
  border-bottom: none;
  padding: 20px 0 0px 0;
  margin: 20px 20px 10px;
}

#productDetails .el-dialog__body {
  padding-top: 0px;
  padding-right: 20px;
}

#productDetails1 .el-form-item__label {
  font-size: 14px;
  color: black;
  font-weight: bold;
  text-align: left;
  padding-left: 20px;
}

#productDetails1 .el-dialog__header {
  border-bottom: none;
  padding: 20px 0 0px 0;
  margin: 20px 20px 10px;
}

#productDetails1 .el-dialog__body {
  padding-top: 0px;
  padding-right: 20px;
}

#productDetails1Trial .el-form-item__label {
  font-size: 14px;
  color: black;
  font-weight: bold;
  text-align: left;
  padding-left: 20px;
}

#productDetails1Trial .el-dialog__header {
  border-bottom: none;
  padding: 20px 0 0px 0;
  margin: 20px 20px 10px;
}

#productDetails1Trial .el-dialog__body {
  padding-top: 0px;
  padding-right: 20px;
}

#productDetails1Competitor .el-form-item__label {
  font-size: 14px;
  color: black;
  font-weight: bold;
  text-align: left;
  padding-left: 20px;
}

#productDetails1Competitor .el-dialog__header {
  border-bottom: none;
  padding: 20px 0 0px 0;
  margin: 20px 20px 10px;
}

#productDetails1Competitor .el-dialog__body {
  padding-top: 0px;
  padding-right: 20px;
}

.dialog-footer {
  margin-top: 10px;
}

#el-button span {
  font-weight: bold;
}

#productSku .buttonStyleActive {
  color: #409eff;
  border-color: #c6e2ff;
  background-color: #ecf5ff;
  width: 154px;
}

#productSku .buttonStyle {
  width: 154px;
}

/*#productSku input::placeholder {*/
/*  text-align: left;*/
/*}*/
</style>
<style scoped>
#productSku>>>.productSku_star label:after {
  content: '*';
  color: #f56c6c;
  margin-left: 4px;
}

.sWei>>>input {
  width: 97%;
  height: 30px;
}

#productSku>>>.productSku_table_cell {
  color: #2b92fa !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/product/productSku.vue